const navText = [
    {
        title: [
            '服务',
            'Service'
        ],
        width: 160,
        subtitle: [
            {
                title: [
                    '私域一站式服务',
                    'Private Domain One-Stop Service'
                ],
                url: '/service-private-traffic'
            },
            {
                title: [
                    '数字营销服务',
                    ' Digital Marketing Service '
                ],
                url: '/service-digital-marketing'
            },
            {
                title: [
                    'IT技术调研',
                    'IT technology research'
                ],
                url: '/service-itdd'
            }
        ]
    },
    {
        title: [
            '产品',
            'Product'
        ],
        width: 120,
        subtitle: [],
        url: '/product'
    },
    {
        title: [
            '行业',
            'Industry'
        ],
        width: 120,
        subtitle: [
            {
                title: [
                    '运动服饰',
                    'Sportswear'
                ],
                url: '/industry-sportswear'
            },
            {
                title: [
                    '3C产品',
                    '3C Product'
                ],
                url: '/industry-consumergoods'
            },
            {
                title: [
                    '酒旅',
                    'Hospitality'
                ],
                url: '/industry-hotel'
            },
            {
                title: [
                    '零售',
                    'Retail'
                ],
                url: '/industry-retail'
            }
        ]
    },
    {
        title: [
            '最新洞察',
            'The latest insight'
        ],
        width: 170,
        subtitle: [],
        url: '/insight'
    },
    {
        title: [
            '关于我们',
            'About us'
        ],
        width: 120,
        subtitle: [
            {
                title: [
                    '概览',
                    'Overview'
                ],
                url: '/about-overview'
            },
            {
                title: [
                    '团队',
                    'Team'
                ],
                url: '/about-team'
            },
            {
                title: [
                    '社会责任',
                    'Social Responsibility'
                ],
                url: '/about-social-resposibility'
            }
        ]
    }
]
const overviewText = {
    title: [
        '依靠人才的力量塑造\n品牌、产品和用户增长', // '\n'表示换行，不需要换行就不用加'\n'
        'Rely on the power of talent to shape \n brands, products and user growth'
    ],
    timeline: [
        {
            title: [
                '2016年，Deansel在上海成立',
                'In 2016, Deansel was founded in Shanghai'
            ],
            content: [
                '来自咨询公司与科技公司的两位创始人，决定用灵活多变的技术和敏锐的战略市场思维创造些新机会',
                'The two founders from consulting firms and technology companies decided to create new opportunities with flexible technology and a keen strategic market mindset'
            ]
        },
        {
            title: [
                '2017年，Deansel开始为互联网巨头提供增长服务',
                'In 2017, Deansel began providing growth services to the internet giant'
            ],
            content: [
                '以对市场与技术结合的商业新思维，Deansel与BAT分别在多个领域进行合作共赢',
                'With a new business thinking that combines market and technology, Deansel and BAT cooperate in a variety of fields'
            ]
        },
        {
            title: [
                '2018年，Deansel推出增长服务',
                'In 2018, Deansel launched its growth services'
            ],
            content: [
                '以最低的成本，撬动增长。Deansel为客户实验并实施高效的增长落地方案，获得国内外50+企业的认可',
                'Leverage growth at the lowest cost. Deansel experimented and implemented an efficient growth landing plan for customers, which was recognized by more than 50 enterprises at home and abroad'
            ]
        }

    ],
    midpart1: [
        {
            img: require('../assets/images/overview_1.jpg'),
            title: [
                '2017-2018，我们与腾讯和宜家联手塑造了釜山广告节金奖和戛纳创意节提名的Babyface',
                'In 2017-2018, we teamed up with Tencent and IKEA to shape the Busan Advertising Festival Gold Award and the Cannes Festival of Creativity nomination for Babyface'
            ],
            content: [
                '通过技术+创意，我们迎来了宜家+腾讯视频两个强大的品牌，创办了2018年年初在北京宜家的体验活动，用户通过拍照便可以在宜家的房间中看到未来孩子从1岁成长到7岁的过程。Deansel运用人脸识别、融合和年轻化技术将3万宜家的客人带到了未来的“家”。',
                'Through technology + creativity, we ushered in the two powerful brands of IKEA + Tencent Video, and created the experience activity of IKEA in Beijing in early 2018, users can see the future growth of children from 1 to 7 years old in the IKEA room by taking photos. Deansel uses facial recognition, fusion and rejuvenation technology to bring 30,000 IKEA guests to the "home" of the future.'
            ]
        },
        {
            img: require('../assets/images/overview_2.jpg'),
            title: [
                '2018年，Deansel开始提供增长黑客服务',
                'In 2018, Deansel began offering growth hacking services'
            ],
            content: [
                'Deansel运营增长引擎和增长黑客方法论服务于企业用户：以Deansel的方法论作为支撑，通过深入的用户研究和数据分析，不断寻找和撬动用户增长杠杆。',
                'Deansel’s operational growth engine and growth hacking methodology serve enterprise users: Supported by Deansel’s methodology, through in-depth user research and data analysis, we constantly seek out and leverage user growth levers.'
            ]
        },
        {
            img: require('../assets/images/overview_3.jpg'),
            title: [
                '2020年，疫情下的增长元年',
                '2020, the first year of growth under the epidemic'
            ],
            content: [
                '由于新冠病毒的蔓延，国际社会所有的线下交易场景受到极大影响，Deansel以低成本持续不断地创造和使用新的获客手段、营销模式为客户创造增长。',
                'Due to the spread of the new coronavirus, all offline transaction scenarios in the international community have been greatly affected, and Deansel has continued to create and use new customer acquisition methods and marketing models to create growth for customers at low cost.'
            ]
        }
    ],
    midpart2: [
        {
            title: [
                '守护象牙',
                'Guard the ivory'
            ],
            content: [
                '2017年，Deansel与WWF及众多自媒体合作，制作保护非洲象的公益宣传网页。',
                'In 2017, Deansel collaborated with WWF and numerous self-media outlets to produce a public service announcement for the conservation of African elephants.'
            ]
        },
        {
            title: [
                '助力梦想',
                'Empower your dreams'
            ],
            content: [
                '2018年，Deansel借助微粒贷的力量，为中国数万位梦想者提供免费实现梦想的技术支持。',
                'In 2018, Deansel leveraged the power of micro-particle lending to provide free technical support to thousands of dreamers in China to realize their dreams.'
            ]
        },
        {
            title: [
                '打击犯罪',
                'Combat crime'
            ],
            content: [
                '2020年，Deansel与百度飞桨合作，创作野生动物映像馆为打击线上非法交易提供算力。',
                'In 2020, Deansel partnered with PaddlePaddle to create a wildlife image gallery that provides computing power to crack down on illegal online trade.'
            ]
        }
    ],//这里帮我想原来网站一样，加一个按钮，在上面这三个的框下面；按钮的文案是“社会责任”然后直接跳转社会责任
    midpart3: [
        {
            img: require('../assets/images/overview_4.jpg'),
            title: [
                '以客户最有利，以Deansel最有利',
                'Maximize customer benefits and Deansel benefits'
            ],
            content: [
                '我们寻找和渴求一群因为挑战而兴奋的人，他们拥有战略思维并在复杂的环境中做出正确决策。',
                'We seek and desire a group of people who are excited by challenges, who have strategic thinking and make the right decisions in complex environments.'
            ]
        },
        {
            img: require('../assets/images/overview_5.jpg'),
            title: [
                '年轻人就该拥有繁华',
                'Young people deserve prosperity'
            ],
            content: [
                '上海新天地，一个以现代与艺术结合的商业中心，是繁冗生活之余惬意的放松之处,也是观望世界与本土,张望昨天和明天的窗口。',
                'Shanghai Xintiandi, a commercial center that combines modernity and art, is a comfortable place to relax after a tedious life, and it is also a window to look at the world and mainland, yesterday and tomorrow.'
            ]
        },
        {
            img: require('../assets/images/overview_6.jpg'),
            title: [
                '与客户一起面对挑战',
                'Face challenges with customers'
            ],
            content: [
                '通过人才与思维的多样性，我们密切地与客户开展创新型、开拓型和极具增长潜力的行业项目，成为客户最信赖的合作伙伴。',
                'Through the diversity of talents and thinking, we closely carry out innovative, pioneering industry projects of great potential to grow with our customers, becoming the most trusted partner of our customers.'
            ]
        }
    ]
}
const wechatText = {
    title: [
        '利用微信生态的社交场景，\n实现企业的跨越式增长',
        'Utilize the social scene of WeChat ecology to achieve leap-forward growth of enterprises'
    ],
    downtext: [
        '发现Deansel的能力',
        'Discover Deansel’s abilities'
    ],
    subtitle: [
        '线上流量价格近年来迅猛地增长，坚持使用传统的获客方法必然带来无法承担的成本。然而，微信生态的崛起早已改变中国的互联网格局，如何利用其数据的开放性、独立性以及用户的量级与停留时长，是企业下一步决策的关键所在。',
        'Online traffic prices have grown rapidly in recent years, and sticking to traditional customer acquisition methods is bound to come with unaffordable costs. However, the rise of the WeChat ecosystem has long changed China’s Internet landscape. And the key to the next decision of enterprises is how to use the openness and independence of its data, as well as the magnitude and stay time of users.'
    ],
    midpart1: { // 方法论1布局
        title: [
            '围绕微信生态内的功能元素，我们探索出了一条为企业定制的增长轨迹',
            'Focusing on the functional elements within the WeChat ecosystem, we have explored a growth trajectory customized for enterprises'
        ],
        content: [
            '“如果微信是一个人，那么它一定是你最好的朋友-张小龙”企业与客户、产品与用户之间的延续行为必然建立在信任之上，而微信的每个模块在生活中都发挥着不可替代的作用。',
            '"If WeChat is a person, then it must be your best friend - Xiaolong Zhang" The continued behavior between enterprises and customers, products and users must be based on trust, and each module of WeChat plays an irreplaceable role in life.'
        ]
    },
    midpart2: { // 方法论2布局
        title: [
            '打通数据孤岛与用户CDP(consumer-data-platform)的建设',
            'Open up data silos and the construction of user CDP (consumer-data-platform)'
        ],
        content: [
            'CRM通过对客户历史行为的数据分析，可以有效地制定营销策略而留住客户、推动销售。但是它却只能关注客户与潜在客户，即有过购买记录和明确购买意向。当数据中台进化到DMP过程，最初的目的是为了给DSP提供全面而海量的广告数据，帮助DSP投放更加精准，但是DMP的最大缺点就在于其仅擅长服务与广告体系，而对运营、销售、品牌方面能力欠佳。反观CDP，最具代表性的公司Segment是北美CDP建设的优秀公司之一，其在北美高度数字化以及成熟的体系下创造的具有极强生命力的数据管理形式，让用户画像更明确，用户轨迹更清晰。而在国内，互联网生态的不同导致了我们疲于将先进的数据思维复制到线上的生态中，但我们发现，完全可以在微信生态中通过打造scrm、CDP、内容中台等完整的体系来帮助企业获取用户、理解用户、转化用户和留存用户。',
            'Through the analysis of data on the historical behavior of customers, CRM can effectively develop marketing strategies to retain customers and promote sales. However, it can only focus on customers and potential customers who have a record of purchase and a clear intention to buy. When the data center evolved into the DMP process, the original purpose was to provide DSP with comprehensive and massive advertising data to help DSP delivery more accurately, but the biggest drawback of DMP is that it is only good at service and advertising system, and its ability to operate, sell and brand is not that good. CDP, in contrast, the most representative company Segment is one of the excellent companies in the construction of CDP in North America, and its data management form with strong vitality created under the highly digitized and mature system in North America makes the user portrait and the user trajectory clearer. In China, the difference in the Internet ecology has led us to be tired of copying advanced data thinking into the online ecology, but we found that it is entirely possible to help enterprises obtain users, understand users, convert users and retain users by creating a complete system such as scrm, CDP, and content middle platform in the WeChat ecosystem.'
        ]
    },
    // midpart3、midpart4目前均为方法论2布局，如果采用方法论1布局，在双斜杠后备注，需添加更多文案，可添加midpart5、6……
    midpart3: {
        title: [
            '用户裂变服务',
            'User fission service'
        ],
        content: [
            '用户会吝啬地分配其有限的认知能力，只想不费脑力地作出选择，而在微信塑造的信任环境下，企业更轻易地利用生态的力量而撬动品牌的增长；\n任何一次微信内产品的设计、流程的搭建或者推广项目的落地，都遵循这个基础的逻辑。增长黑客的核心方法也是要塑造病毒效应，利用用户分享免费或者低价地让企业产品获得曝光和转化。病毒效应（裂变）项目的促成有两点核心要素：1 洞察人性的创意 2 成熟的微信裂变路径;\n Deansel服务于众多创新型企业，横跨互联网、快销品、耐用消费品、金融、房地产、汽车、航空等等行业，为其订制和创造众多微信生态裂变服务，低成本撬动用户增长。',
            'Users will be stingy to allocate their limited cognitive ability, just want to make choices without brainstorming, and in the trust environment shaped by WeChat, enterprises can more easily use the power of ecology to leverage brand growth; any product design, process construction or promotion project landing in WeChat follows the logic of this foundation. The core approach of growth hacking is also to create a viral effect, using user sharing to expose and convert enterprise products for free or at low prices. There are two core elements in the promotion of the viral effect (fission) project: 1.Insight into the creativity of human nature 2. Mature WeChat fission path; Deansel serves many innovative enterprises, spanning the Internet, fast-moving goods, consumer durables, finance, real estate, automotive, aviation and other industries, customizing and creating many WeChat ecological fission services for them, and leveraging user growth at low cost.'
        ]
    },// midpart3 部分用方法二的布局，但是3着个部分下面要跟2一样有个图片，图片我最后再配
    midpart4: {
        title: [
            '私域流量搭建与精准触达用户',
            'Private domain traffic construction and accurately reaching users'
        ],
        content: [
            '越来越多的企业发现，单纯的广告投放获取销售线索并进行转化的方式正在面临极大的成本挑战，企业必须要寻找和组建一个增长团队来探索和创造新的可持续的获客方式；Deansel作为外部大脑和行业专家的角色，帮助众多企业搭建符合其特点的私域流量增长计划，Deansel掌握着各行各业在面对市场复杂环境作出的行之有效的决策以及实施方案，以用户标签化的数据、裂变化的活动、高质量的内容、创新型的商业模式和用户精准触达与推送的五个维度更加体系化地为企业搭建私域流量，与企业一起探索和实践增长。',
            'More and more companies are finding that the way to obtain sales leads and convert through simple advertising is facing great cost challenges, and companies must find and form a growth team to explore and create new sustainable ways to acquire customers; Deansel, as an external brain and industry expert helps many companies build private domain traffic growth plans that meet their characteristics, Deansel controls the effective decisions and implementation plans made by all walks of life in the face of the complex market environment. With user-tagged data, fission activities, high-quality content, innovative business models and five dimensions of accurate user reach and push, we can more systematically build private domain traffic for enterprises, and explore and practice growth with enterprises.'
        ]
    }
}
const ptrafficText = {
    title: [
        '利用微信生态，\n实现企业跨越式增长',
        'Utilize the WeChat ecology to achieve leap-forward growth of enterprises'
    ],
    downtext: [
        '发现Deansel的能力',
        'Discover Deansel’s abilities'
    ],
    subtitle: [
        '线上流量价格近年来迅猛地增长，坚持使用传统的获客方法必然带来无法承担的成本。然而，微信生态的崛起早已改变中国的互联网格局，如何利用其数据的开放性、独立性以及用户的量级与停留时长，是企业下一步决策的关键所在。',
        'Online traffic prices have grown rapidly in recent years, and sticking to traditional customer acquisition methods is bound to come with unaffordable costs. However, the rise of the WeChat ecosystem has long changed China’s Internet landscape. And the key to the next decision of enterprises is how to use the openness and independence of its data, as well as the magnitude and stay time of users.'
    ],
    midpart1: { // 方法论1布局
        title: [
            '围绕用户与用户产生链接的微信生态，我们探索出了一条为企业定制增长轨迹的方法。',
            'Focusing on the functional elements within the WeChat ecosystem, we have explored a growth trajectory customized for enterprises'
        ],
        content: [
            '流量价格水涨船高，2010年到2020的十年间，移动互联网崛起、弯道超车快速地让所有用户“上线”，品牌之间对增量市场的竞争日驱激烈。2020年后的下一个十年，则是存量市场的竞争。\n流量如何变成留量，如何有效利用留量为品牌创造更大价值，增强品牌与用户的链接并增加用户的复购是未来品牌之间的硬仗。',
            'In the decade from 2010 to 2020, the rise of the mobile Internet and the rapid overtaking of curves have allowed all users to "go online", and the competition between brands for the incremental market is fierce. The next decade after 2020 will be competition in the stock market. How to turn traffic into retention, how to effectively use retention to create greater value for brands, enhance the link between brands and users and increase user repurchase is an hard battle between future brands.',
        ]
    },
    midpart2: { // 方法论2布局
        title: [
            '能落地的私域才有未来',
            'Only the private domain that can land will have a future'
        ],
        content: [
            '私域已经跨过概念层面，并开始植入到各行业中。不同垂类对私域的诉求大相径庭，很多企业把私域做成了CXO工程，无法有效地落地执行并成为企业的竞争优势。\n私域需要成为组织中不可或缺的能力和占领市场的武器，零售行业中的品牌、经销商、门店，文旅住宿行业中的品牌、业主、线上线下客服，各行业中每个节点的受益者都要付出一定的精力才能组建强大的私域体系。其中的制度、激励措施、工具、执行MVP、培训等等都应依托于一套完整且实用的私域建设方法。',
            'Private domains have crossed the conceptual level and are beginning to be implanted in various industries. The demands of different vertical classes on private domains are very different, and many enterprises have made private domains into CXO projects, which cannot be effectively implemented and become the competitive advantage of enterprises. The private domain needs to become an indispensable ability in the organization and a weapon to occupy the market, brands, distributors, stores in the retail industry, brands, owners, online and offline customer service in the cultural tourism and accommodation industry, and the beneficiaries of each node in each industry must pay a certain amount of energy to form a strong private domain system. The systems, incentives, tools, MVP implementation, training, etc. should all rely on a complete and practical private domain construction method.'
        ]
    },
    // midpart3、midpart4目前均为方法论2布局，如果采用方法论1布局，在双斜杠后备注，需添加更多文案，可添加midpart5、6……
    midpart3: {
        title: [
            'SCRM登上历史舞台，成为数字化到提升品牌营收的破局点',
            'SCRM has taken the stage of history and become a breaking point for digitalization to enhance brand revenue'
        ],
        content: [
            'SCRM是在中国的移动互联网沃土中成长起来的工具，在触点更丰富、互动能力更强的微信生态中，更是品牌与用户产生链接的地方。\n所以，在私域里，品牌方直接承担了流量经营方所做的一切工作，从用户的拉新、互动到转化和复购，这对于大部分实体产品的品牌来说步履维艰。而相对于高频的2C产品来说，中低频的产品因为用户决策链路长，触点又分散，很难短期见效，长期又因为各个平台之间的数据割裂导致无法对订单全面溯源，让很多品牌坚持又放弃，放弃又重启，反反复复。\n能利用好生态内不同形式的触点，提高用户的互动频次，设计好完整的用户线上体验流程，才能把SCRM产品利用到极致，让它成为品牌传递价值的工具。',
            'SCRM is a tool that has grown up in the fertile soil of China’s mobile Internet, and in the WeChat ecosystem with richer contacts and stronger interaction capabilities, it is also a place where brands and users are linked. Therefore, in the private domain, the brand directly undertakes all the work done by the traffic operator, from the acquisition and interactive to the conversion and repurchase, which is difficult for most brands of physical products. Compared with high-frequency 2C products, medium and low frequency products are difficult to achieve short-term results because of the long user decision-making link and scattered contacts, and for a long time, because of the data separation between various platforms, it is impossible to fully trace the source of orders, so that many brands insist on giving up, giving up and restarting, and repeating. Can make good use of different forms of contact points in the ecosystem, improve the frequency of user interaction, and design a complete user online experience process, in order to make the use of SCRM products to the extreme, so that it can become a tool for brands to transmit value.'
        ]
    }
}
const marketingText = {
    title: [
        '创造新时代、新生态和新模式\n的数字营销项目',
        'Create a new era, a new ecology and a new modeln digital marketing projects'
    ],
    downtext: [
        '发现Deansel的能力',
        'Discover Deansel’s abilities'
    ],
    subtitle: [
        '在任何时代，市场营销始终是客户获取和品牌宣传的核心，而对于现在移动互联网流量的红海期，盲目的购买或投放只会在未来的竞争中受阻。通过理解用户诉求并借助创意、营销和技术手段创造出的作品，才是这个时代所需。',
        'In any era, marketing has always been the core of customer acquisition and brand promotion, and for the current Red Sea period of mobile Internet traffic, blind purchase or delivery will only be hindered in the future competition. Works created through an understanding of user demands and the use of creative, marketing and technical means are what this era requires.'
    ],
    midpart1: { // 方法论2布局
        title: [
            '以AI技术赋能广告创意，抓住用户猎奇心态',
            'Empower advertising creativity with AI technology and capture the curiosity mentality of users'
        ],
        content: [
            '近10年我们在戛纳国际创意节上发现，越来越多的互联网和科技型企业包揽各项大奖，把以往以消费品创意+TVC表现形式的霸主们请下擂台，代表性的Google、Facebook等等蝉联各种全场最佳；不难看出，围绕技术和用户数据制造新颖独特乃至千人千面的体验，逐步获得了市场的认可；毕竟，营销方式和产品也需要跟随时代的变化进行升级改造，根据情绪而定制鸡尾酒的情绪识别点酒屋、找到世界货币上跟你最想的那一张脸、运用AI的力量帮你为野生动物作画等等都是我们借助AI的力量带给用户革新的体验。',
            'In the past 10 years, we have found at the Cannes International Festival of Creativity that more and more Internet and technology-based enterprises have won various awards, invited the overlords of the past consumer goods creativity + TVC expression to the stage, and the representative Google, Facebook, etc. have won various bests in the field; it is not difficult to see that around the technology and user data to create a novel and unique experience and even thousand-people-with-thousand-faces experience, and gradually gained the recognition of the market; after all, marketing methods and products also need to be upgraded with the changes of the times. The mood recognition point wine house that customizes cocktails according to emotions, finds the face you want the most on the world currency, and uses the power of AI to help you paint wild animals, etc. are all experiences that we bring to users with the power of AI.'
        ]
    },  // midpart1 之后加一张图，就是板式C  
    midpart2: { // 方法论1布局
        title: [
            '利用私域流量，搭建千人千面的营销中台',
            'Use private domain traffic to build a thousand-people-with-thousand-faces marketing middle platform '
        ],
        content: [
            '2020的黑天鹅事件让线下门店集体受挫，而线上又面临着流量激战。企业正在模仿欧美独立站的模式，建设自己的私域流量，从而在社交生态内建设千人千面的营销体系，行业竞争格局日渐形成。',
            'The black swan event in 2020 has caused offline stores to suffer collective setbacks, and online is facing a fierce traffic battle. Enterprises are imitating the model of independent stations in Europe and the United States, building their own private domain traffic, so as to build a thousand-people-with-thousand-faces marketing system  in the social ecosystem, and the industry competition pattern is gradually forming.'
        ]
    },
    // midpart2后面加一张图 板式C
    midpart3: {
        title: [
            '建设短视频内容，制作跨平台短视频+直播矩阵',
            'Construct short video content and produce cross-platform short video + live broadcast matrix'
        ],
        content: [
            '在当今短视频+直播内容百花齐放的格局下，合作直播带货作为一种促销性的内容行为，较高的佣金和退货率一直是品牌方很难把ROI做高的阻碍，而考人力成本支撑的mcn企业成为了矛盾的中间体。企业需要自己建设视频矩阵和视频内容，通过视频内容的内外结合带动品牌和销量的提升，跨平台地将用户整合到自己的私域流量中来。流量红利消失意味着获取用户成本的上升，目前企业需要的是对现有和潜在客户的复购刺激，持续运营，这就对内容的多样性、持续性和新颖性有更高的要求。运营是下一场线上流量留存战的重要武器。',
            'In today’s pattern of short video + live content blooming, cooperative live streaming with goods as a promotional content behavior, higher commissions and return rates have always been difficult for brands to make ROI high obstacles, and mcn enterprises supported by labor costs have become contradictory intermediates. Enterprises need to build their own video matrix and video content, drive brand and sales through the combination of video content inside and outside, and integrate users into their own private domain traffic across platforms. The disappearance of traffic dividend means the rise in the cost of obtaining users, and what enterprises need at present is to stimulate the repurchase of existing and potential customers and continue to operate, which has higher requirements for the diversity, sustainability and novelty of content. Operations are an important weapon in the next online traffic retention war.'
        ]
    }
}
const itddText = {
    title: [
        '由表及里，披沙拣金\nIT技术尽职调研降低投资风险',
        'From the outside to the inside, sort out the fine gold from the sand. IT technology make due diligence to reduce investment risk'
    ],
    downtext: [
        '发现Deansel的能力',
        'Discover Deansel’s abilities'
    ],
    subtitle: [
        '近5年，在互联网企业的投资与并购中，“技术爆炸”的跃迁带来的信息不对称日渐严重。数据造假、版本漏洞、内容造假等等暗藏着巨大的投资风险，但仅凭财务和法务的尽职调研均难以发现其中的猫腻。因此，更专业的面向标的公司的IT技术尽职调研成为防范风险的坚实壁垒。',
        'In the past five years, in the investment and mergers and acquisitions of Internet companies, the information asymmetry brought about by the jump of "technology explosion" has become increasingly serious. Data fraud, version vulnerabilities, content fraud, etc. hide huge investment risks, but it is difficult to find them based on financial and legal due diligence alone. Therefore, more professional IT technology due diligence for target companies has become a solid barrier to risk prevention.'
    ],
    midpart1: { // 方法论1布局
        title: [
            'IT尽职调研链条由6个主要环节构成，遵循3条主要原则',
            'The IT due diligence chain consists of 6 main links and follows 3 main principles'
        ],
        content: [
            'ITDD由6个主要环节构成：1) 根据标的公司的行业以及数据和产品特点制定相应的方案；2) 分析程序的架构，对其可能产生的风险进行解读并给出优化建议；3) 把所有数据来源之间打通，包括标的提供的后端所有数据表以及必要的爬虫和埋点；4) 结合标的公司提供的数据内容，表结构以及必要的爬虫和埋点统计，全面核实数据真实性；5) 标的公司提供开源表格，Deansel对其使用的开源代码授权以及维护风险进行分析；6) 以系统架构，数据和开源代码三重维度评估标的公司整体投资风险。',
            'ITDD consists of 6 main links: 1) according to the target company’s industry and data and product characteristics to develop the corresponding program; 2) analyze the structure of the program, interpret the risks it may generate and give optimization suggestions; 3) connect all data sources, including all data tables provided by the target and necessary crawlers and trackings; 4) combine the data content provided by the target company, the table structure and the necessary crawler and trackings statistics to fully verify the authenticity of the data; 5) the target company provides open source tables Deansel analyzes the licensing and maintenance risks of the open source code it uses; 6) evaluates the overall investment risk of the target company in terms of system architecture, data, and open source code.'
        ],
        content2: [
            'ITDD遵循三大基本原则：第一，从业务特点/产品类型出发来建立分析模型而验证业绩真实性与技术可靠性；第二，异步执行不同任务，保证交付时间，以互联网产品敏捷开发的方式执行TDD项目；第三，注重开源代码的维护能力和数据的批量处理，以代码化的方式优化流程并提高处理能力与速度。',
            'ITDD follows three basic principles: first, from the business characteristics/product types to establish an analytical model to verify the authenticity of performance and technical reliability; second, asynchronously perform different tasks, ensure delivery time, and execute TDD projects in the way of agile development of Internet products; third, pay attention to the maintenance of open source code and batch processing of data, optimize processes in a coded manner and improve processing power and speed.'
        ]
    },  // midpart1 之后加一张图，就是板式C  
    midpart2: { // 方法论2布局
        title: [
            '通过对系统架构和数据结构的四大分析模块，验证标的数据的可靠性',
            'Through the four major analysis modules of system architecture and data structure, we can verify the reliability of the underlying data'
        ],
        content: [
            '在ITDD的过程中，我们通过IT系统架构解读、基础数据核查、用户核查和核心数据核查四大分析模块来检查标的公司数据的可靠性。我们将对标的公司技术管理层访谈来深入解析产品的系统架构，其中访谈内容主要为公司产品发展过程中的架构变化、架构相关负责人的变化及架构的未来规划等。我们根据具体的业务模式，对标的公司的动、静态数据库做简要分析，脱敏导出标的的数据库核心表单，并通过现场测试核查数据的一致性。在用户核查方面，我们将抽样核查用户消费情况、用户活跃情况的真实性，通过追踪用户行为、追溯用户来源、IP等来探究用户行为的合理性。我们还将对标的公司的核心业务表单进行核查，分析表单中消费行为的轨迹，并校验产品运营模式的效率和可行性。',
            'In the process of ITDD, we check the reliability of the target company’s data through four analysis modules: IT system architecture interpretation, basic data verification, user verification and core data verification. We will conduct in-depth analysis of the system architecture of the product through interviews with the technical management of the target company, in which the interview content is mainly about the structural changes in the process of the company’s product development, the changes in the person in charge of the architecture and the future planning of the architecture. According to the specific business model, we make a brief analysis of the dynamic and static databases of the target company, desensitize and export the core form of the target database, and verify the consistency of the data through field testing. In terms of user verification, we will check the authenticity of user consumption and user activity by sampling, and explore the rationality of user behavior by tracking user behavior, tracing user sources, IP, etc. We will also review the core business forms of the target company, analyze the trajectory of consumer behavior in the form, and verify the efficiency and feasibility of the product operating model.'
        ]
    },
    // midpart2后面加一张图 板式C
    midpart3: {
        title: [
            '通过对开源代码安全、期限以及版本管理的审核，预见相应风险',
            'Anticipate risks by auditing open source code security, deadlines, and version management'
        ],
        content: [
            '在高速发展的互联网企业中，忽略代码的合规和安全性，可能造成致命的数据问题，使产品面临黑客攻击、数据泄露/丢失的巨大危害。因此，ITDD需要通过对开源代码安全、期限以及版本管理进行审核，从而预见相应风险。这就需要先由标的整理开源依赖清单，包括开源代码所使用所有开源组件，依赖项和许可证信息。再由ITDD系统检查表单中开源代码、开源组件及其依赖项的合规性，并检查开源代码风险以及过期组件和依赖，以此来生成生成开源风险报告、安全漏洞报告及高严重性错误报告。最后ITDD系统将根据所有调研结果生成完整的开源尽职调研报告。',
            'In a high-speed Internet enterprise, ignoring the compliance and security of the code may cause fatal data problems, making the product face the huge harm of hacking and data leakage/loss. Therefore, ITDD needs to anticipate the corresponding risks by auditing the security, deadlines, and version management of open source code. This requires the target to first compile an open source dependency list, including all open source components, dependencies, and license information used by the open source code. The ITDD system then checks the compliance of open source code, open source components and their dependencies in the form, and checks open source code risks as well as expired components and dependencies to generate open source risk reports, security vulnerability reports and high severity error reports. Finally, the ITDD system will generate a complete open source due diligence report based on all the survey results.'
        ]
    }
}
const sesameeatsText = {
    downtext: [
        '创新产品案例',
        'Innovative product examples'
    ],
    subtitle: [
        '平均每天有2.56亿份外卖被送往用户手中，其中至少分别产生2.56亿个餐盒和塑料袋。但是，外卖盒基本上不会得到有效地回收利用。为什么不让餐盒像家中餐具一样不断循环利用呢？中国未来的环保消费潜力是否巨大呢？带着种种疑问，我们开启了芝迷的建设。',
        'An average of 256 million takeaways are delivered to users every day, of which at least 256 million lunch boxes and plastic bags are generated, respectively. However, takeaway boxes are basically not recycled efficiently. Why not keep the lunch box recycled like the tableware in the home? Is China’s future potential for environmental protection consumption huge? With all kinds of questions, we started the construction of sesame eats.'
    ],
    midpart1: {
        title: [ // 板式A布局
            '以中国独有的互联网生态帮助海外客户进行项目落地',
            'With China’s unique Internet ecology to help overseas customers land projects'
        ],
        content: [
            'Deansel凭借多年对国内互联网生态的理解，帮助客户落地线上线下创新模式，规划用户链路和产品流程。2019-2020在上海兴业太古汇实施落地环保用餐体验“芝迷”，共同探索国内环保与健康理念的未来。',
            'With years of understanding of the domestic Internet ecology, Deansel helps customers land online and offline innovation models, plan user links and product processes. 2019-2020 In Shanghai HKRI Taikoo Hui, the implementation of the land-based environmental protection dining experience "Sesame easts" will jointly explore the future of domestic environmental protection and health concepts.'
        ]
    },
    midpart2: { // 板式B布局，需添加更多板式A/B的文案可添加midpart4、5……,在双斜杠后备注采用板式A或B
        title: [
            '推开传统的大门走出传统-新创商业模式',
            'Pushing the door of tradition out of tradition - new business models'
        ],
        content: [
            '获客上我们采取初期冷启动-中期线下拉新-爆发期-线上裂变线下拉新并行的策略，最终我们获取了超过一半的商业楼办公用户，成功获取近3000个订单，平均每单达到近100块的水准，付购率达到53%。我们引进了10+知名餐厅主动合作加入平台，成功验证这个创新的项目是符合用户期待的。这样的成绩超出客户的期待，成功突破初始设定的KPI，达成率217%。Deansel不只帮助成功企业增长，对于初创企业从0到1的增长也能够提供专业的创新策略。',
            'In terms of customer acquisition, we adopted the strategy of early cold start - medium-term offline acquisition - outbreak period - online fission offline acquisition, and finally we obtained more than half of the commercial building office users, successfully obtained nearly 3,000 orders, an average of nearly 100 yuan per single, and the purchase rate reached 53%. We have introduced 10+ well-known restaurants to actively cooperate to join the platform, and successfully verified that this innovative project is in line with user expectations. This achievement exceeded the expectations of customers, and successfully broke through the initial KPI, with a completion rate of 217%. Deansel not only helps successful companies grow, but also provides a professional innovation strategy for the growth of start-ups from 0 to 1.'
        ]
    },
    midpart3: {
        left: {
            title: [
                '角色',
                'Role'
            ],
            content: [
                'Deansel帮助客户以增长黑客方法论为基础，持续改进打造0-1的项目实施，并在关键性决策上起到带头作用，为项目的顺利实施落地和发展保驾护航。',
                'Deansel helps clients continuously improve the implementation of 0-1 projects based on the growth hack methodology, and plays a leading role in key decisions to escort the smooth implementation and development of projects.'
            ]
        },
        right: {
            title: [
                '能力',
                'Capability'
            ],
            content: [
                '整体方案的策略优化调整\n产品开发\n形象官网的建设\n建立完整的可视化数据库体系\n打通线下通路\n线上线下流量增长\n内容营销-公众号的经营\n创新商业模式的验证',
                'Strategic optimization and adjustment of the overall plan\n Product development\n Construction of the image official website\n Establish a complete visual database system\n Open up offline channels\n Online and offline traffic growth\n Content marketing - Operation of the official account\n Verification of innovative business models'
            ]
        }
    },
    articles: [
        {
            from: [
                '兴业太古汇服务号',
                'HKRI Taikoo Hui Official Accounts'
            ],
            title: [
                'sesame eats芝迷，从用餐改变世界',
                'Sesame eats, changing the world from dining'
            ],
            url: 'https://mp.weixin.qq.com/s/XKs1lFD5i6uXLh3Q9n3fMQ'
        },
        {
            from: [
                'sesame eats 芝迷',
                'sesame eats'
            ],
            title: [
                '芝迷 - 创造更多优质体验',
                'sesame eats - Create More Premium Experiences'
            ],
            url: 'https://mp.weixin.qq.com/s/Z6H-pLCG0Cm2q8tTImwD2w'
        },
        {
            from: [
                'Deansel'
            ],
            title: [
                '快速试错，加速成功-如何利用持续创新打造成功的商业模式',
                'Fast trial-and-error, accelerate success – how to build a successful business model with continuous innovation'
            ],
            url: '',
            routerUrl: '/article5'
        }
    ]
}
const wildlifeText = {
    downtext: [
        '借助AI的力量保护野生动物',
        'Protect wildlife with the power of AI'
    ],
    subtitle: [
        '每个生命都有其存在的意义，用户置身馆中身临其境，看着触目惊心的动物故事，点击为它作画按钮后会获得一幅由AI生成的专属动物画作，以此呼吁大众拒绝野生动物非法交易，保护野生动物。',
        'Every life has its own meaning, users are immersed in the museum, looking at the shocking animal story, clicking the Paint for it button will get an exclusive animal painting generated by AI, in order to call on the public to reject the illegal trade in wild animals and protect wild animals.'
    ],
    midpart1: {
        title: [ // 板式A布局
            '用为野生动物作画的方式，展现技术能力，传递技术温度',
            'In the way of painting wild animals, we show our technical ability and transmit the warmth of technology'
        ],
        content: [
            '《野生动物映像馆》是百度飞浆联合国际爱护动物基金会（IFAW）开发的一个技术+艺术的数字项目，让每个人都能利用AI作画，给出专属于他的惊艳视效。',
            '"Wildlife Image Museum" is a technology + art digital project developed by PaddlePaddle and the International Fund for Animal Welfare (IFAW), allowing everyone to use AI to paint and give him stunning visual effects.'
        ]
    },
    midpart2: { // 板式B布局，需添加更多板式A/B的文案可添加midpart4、5……,在双斜杠后备注采用板式A或B
        title: [
            '野生动物画展被《人民日报》置顶',
            'The wildlife painting exhibition was topped by the People’s Daily'
        ],
        content: [
            '4月22日，百度系APP开屏和百度doodle全天全量推送，人民日报APP在首页推送并在服务号文章置顶，陈赫、黄景瑜、杨紫和周冬雨四位明星在微博发声……截止至4月23日零点，“野生动物映像馆”单日PV、UV、生成画作数均过百万。当然，我们最大的成绩不是这些漂亮的数据，而是让百万用户意识到保护野生动物的重要性。',
            'On The 22nd of July, Baidu sub-app Splash Ad and Baidu doodle open full volume push throughout the day, People’s Daily APP push on the home page and the official account article top, Chen He, Huang Jingyu, Yang Zi and Zhou Dongyu four stars on Weibo voice for that... As of 00:00 on April 23, the number of PV, UV, and generated paintings in a single day of the "Wildlife Image Museum" has exceeded one million. Of course, our biggest achievement is not this beautiful data, but the importance of protecting wildlife in millions of users.'
        ]
    },
    midpart3: {
        left: {
            title: [
                '技术：',
                'Technology'
            ],
            content: [
                'Deepdream的图像训练\nAI风格迁移训练\n多端多机型适配\n服务器集群处理',
                'Deepdream image training\nAI style migration training\nMultiple-terminal matched with multi-model adaptation\nServer cluster processing'
            ]
        },
        right: {
            title: [
                '角色：',
                'Role'
            ],
            content: [
                '产品场景与主题设计\n风格迁移AI训练\n产品设计开发\n产品适配与维护',
                'Product scenario and theme design\nSystem migration and AI training\nProduct design and development\nProduct adaptation and maintenance'
            ]
        }
    },
    articles: [
        {
            from: [
                '数英网',
                'Digitaling'
            ],
            title: [
                '进入「野生动物映像馆」，用AI为逝去的动物作画',
                'Enter the "Wildlife Mirror" and use AI to paint dead animals'
            ], // 悬浮有效果 link：https://www.digitaling.com/projects/111747.html
            url: 'https://www.digitaling.com/projects/111747.html'
        },
        {
            from: [
                '中国日报',
                'China Daily'
            ],
            title: [
                '百度联合IFAW推全球首个“濒危物种AI守护官“，已筛查近25万图片信息',
                'Baidu and IFAW launched the world’s first "endangered species AI guardian officer", which has screened nearly 250,000 picture information'
            ], // 悬浮有效果 link：https://ex.chinadaily.com.cn/exchange/partners/82/rss/channel/cn/columns/snl9a7/stories/WS5e9ff4dca310c00b73c78dfc.html
            url: 'https://ex.chinadaily.com.cn/exchange/partners/82/rss/channel/cn/columns/snl9a7/stories/WS5e9ff4dca310c00b73c78dfc.html'
        },
        {
            from: [
                'Deansel服务号',
                'Deansel official accout'
            ],
            title: [
                '有温度的AI',
                'AI with warmth'
            ], // 文章还没写出来，像这种公众号的，要鼠标悬浮出个二维码在旁边，我把文章link再更新
            url: ''
        }
    ]
}
const huazhuText = {
    title: [
        '酒旅品牌私域服务',
        'Private domain service for the Hospitality brands'
    ],
    downtext: [
        '打造以用户为核心的线上线下服务模式',
        'Create a user-centric online and offline service model'
    ],
    subtitle: [
        '私域战略的核心就是让品牌与用户建立直接互动，并通过小程序、公众号、私聊和社群全面建设用户的品牌心智，借力微信生态天然的社交属性，在互动能力上远超其他任何线上用户触达方式。',
        'The core of the private domain strategy is to allow brands to establish direct interaction with users, and to comprehensively build users’brand minds through mini programs, public accounts, private chats and communities, leveraging the natural social attributes of WeChat ecology, and far surpassing any other online user reach in terms of interaction capabilities.'
    ],
    midpart1: {
        title: [ // 板式A布局
            '后疫情时代的酒旅业，急需突破OTA对流量的绝对把控，打通直接与用户连接的桥梁',
            'In the post-epidemic era, the Hospitality urgently needs to break through the absolute control of traffic by OTAs and open up a bridge directly connecting with users'
        ],
        content: [
            '疫情加速了用户对线上服务的依赖性，迫使众多行业加入到私域流量的建设中，通过直接与用户沟通的方式占领用户心智。酒旅行业属于重线下服务型产品，在线上服务中有天然的劣势，在这一次成长机遇中，只有快速实施落地，才能确定领先地位并且超越竞争对手。',
            'The epidemic has accelerated users’dependence on online services, forcing many industries to join the construction of private domain traffic and occupy users’ minds through direct communication with users. The Hospitality Industry is a heavy offline service product and there is a natural disadvantage in online service. In this growth opportunity, only rapid implementation of the landing, in order to determine the leading position and surpass competitors. ',
            
        ]
    },
    midpart2: { // 板式B布局，需添加更多板式A/B的文案可添加midpart4、5……,在双斜杠后备注采用板式A或B
        title: [
            '私域流量池迅速建立，为品牌线上线下赋能',
            'Private domain traffic pools were rapidly established to empower brands online and offline'
        ],
        content: [
            '后疫情时期，品牌需要新的能力随时应对危机并进行良性扩张，Deansel通过持续地用户拉新和裂变获客，在短时间内扩张私域流量池，微信生态内订单迅速提升，酒店线上线下活动参与度饱和，用户UGC内容产出成倍增长。',
            'In the post-epidemic period, brands need new capabilities to respond to crises at any time and carry out benign expansion, Deansel through continuous user pulling and fission customer acquisition, expanding the private domain traffic pool in a short period of time, the weChat ecosystem orders increased rapidly, the participation of online and offline activities in hotels was saturated, and the output of user UGC content doubled.'
        ]
    },
    midpart3: {
        left: {
            title: [
                '技术：',
                'Technology'
            ],
            content: [
                'Deansel以其深耕私域建设的丰富经验，研发出专门用于酒旅业的一套可复用的工具和服务，为项目的实施与发展提供基建基础。',
                'Deansel has developed a set of reusable tools and services specifically for the Hospitality Industry to provide the infrastructure for the implementation and development of the project.'
            ]
        },
        right: {
            title: [
                '角色：',
                'Role'
            ],
            content: [
                '打通线下线上通路\n流量裂变及增长\n私域数据分析\n定制化社群运营指导\n内容营销及转化\n品牌kol/koc培养',
                'Open up offline and online channels\n Traffic fission and growth\n Private domain data analysis\n Customized community operation guidance\n Content marketing and conversion\nBrand kol/koc cultivation'
            ]
        }
    }
}
const consumerText = {
    title: [
        '3C产品私域服务',
        '3C product private domain service'
    ],
    downtext: [
        '打造以用户为核心的线上线下服务模式',
        'Create a user-centric online and offline service model'
    ],
    subtitle: [
        '将线上线下、经销商、零售门店和品牌方全部通过私域连接在一起，打破数据孤岛，围绕用户提供健全的服务体系。',
        'Connect online and offline, distributors, retail stores and brand parties all together through private domains, break down data silos, and provide a sound service system around users.'
    ],
    midpart1: {
        title: [ // 板式A布局
            '消费品需要在微信这个“场”内，完成人与货品的匹配',
            ''
        ],
        content: [
            '快销品跟耐消品，高客单跟低客单，消费品作为一个庞大的行业在私域中也分支众多，跟随着不同的决策周期和使用消耗周期、不同的消费人群分层和不同的单价，在私域运营精力跟运营方式方法上的区分也是所有行业内最为复杂的。快销品更多的是分层精细化运营，而耐消品更多的是选品和消费精力的匹配。消费品的核心操盘逻辑是以“人”为中心的消费升级，想要以用户为中心就一定要加强与用户的黏着力，需要更高效地触达、更频繁地互动、更全域的数字化，而这些都可以由私域服务完成。',
            'Fast-selling products and durable consumer goods, high customer orders and low customer orders, consumer goods as a huge industry in the private domain also have many branches, followed by different decision-making cycles and consumption cycles, different consumer group stratification and different unit prices, in the private domain operation energy and operation methods of the distinction is also the most complex in all industries. Fast-selling products are more hierarchical and refined operations, while consumer-resistant products are more about the matching of selection and consumption energy. The core trading logic of consumer goods is to make "people" as the center of consumption upgrade, if you want to be user-centric, you must strengthen the adhesion with users, need to reach more efficiently, interact more frequently, and digitize more globally, and these can be completed by private domain services.'
        ]
    },
    midpart2: { // 板式B布局，需添加更多板式A/B的文案可添加midpart4、5……,在双斜杠后备注采用板式A或B
        title: [
            '下一个十年，是微信的十年',
            'The next decade is the decade of WeChat'
        ],
        content: [
            '依托于社交网络带来的流量并不是取之不尽的，随着信息的进一步爆炸，更多企业加入到私域流量的战队中，用户手上的联系人开始飞速增加，阅读和互动的频次也会越来越低。只有更快投入到私域的战斗中，才能在红利尚存的市场中赢得主导地位，加速数字化转型，进一步接近直面消费者的以用户为中心的品牌运行模式。',
            'Relying on the traffic brought by social networks is not inexhaustible, with the further explosion of information, more companies join the team of private domain traffic, the number of contacts in the hands of users begins to increase rapidly, and the frequency of reading and interaction will become lower and lower. Only by investing more quickly in the battle of the private domain can we win the dominant position in the market where dividends still exist, accelerate digital transformation, and further approach the user-centric brand operation model that directly faces consumers.'
        ]
    },
    midpart3: {
        left: {
            title: [
                '技术：',
                'Technology'
            ],
            content: [
                'Deansel鼎栈SCRM，\n贯通服务用户生命周期，\n支持多平台的数据链接',
                'DeanselSCRM,\nconnect through the service user lifecycle,\n support multi-platform data linking'
            ]
        },
        right: {
            title: [
                '角色：',
                'Role'
            ],
            content: [
                '私域增长咨询\n私域模式落地\n数字化产品研发\n人员培训\n运营',
                'Private domain growth consulting\n Private domain model landing\nDigital product development\n personnel training\nOperation'
            ]
        }
    }
}
const sportsText = {
    title: [
        '运动服饰',
        'Sportswear Industry'
    ],
    downtext: [
        '打造以用户为核心的线上线下服务模式',
        'Create a user-centric online and offline service model'
    ],
    subtitle: [
        '微信会员运营体系解决方案，为客户提供丰富多样、技术领先和富有创意的会员关系解决方案。',
        'Solutions to WeChat membership operation system, providing customers with a variety of diverse, technologically edged and creative solutions to member relationship.'
    ],
    midpart1: {
        title: [ // 板式A布局
            '下一个5年，是运动服饰的5年',
            'The next 5 years belong to Sportswear Industry.'
        ],
        content: [
            '层出不穷的新运动和新的生活方式不断充斥在新消费者中，传统的运动也被新一代的装备、活动和竞技方式所改变；在未来，更注重健康和环保是所有中高端消费者的共识，他们在不断追求更时尚、愉悦身心和刺激运动的过程中，带来的无论是专业装备还是运动服饰的消费都是未来仅存的增长点，尤其是高端运动服饰。随着国内人均GDP在19年达到1万美金，在历史发展的必然进程中，新一代的高端消费者更注重表达自我，更注重个性，更注重健康，所有的变化都将带来对高端垂类运动服饰的需求。',
            'Newly emerging categories of sports and lifestyles are proliferating among new consumers. Simultaneously, traditional sports are being modified by a new generation of equipment, activities and competitive ways. In this context, the whole group of middle- and high-end consumers is reaching a consensus, to place more and more emphasis on well-being and environmental protection. Their consumption of professional equipment and sportswear in pursuit of style, delight and stimulation stands for the biggest growth point in the coming future. This is the case, especially for high-end sportswear. As the  GDP per capita of China reached $10,000 in 2019, an inevitable trend reveals itself: the new generation of high-end consumers are keener on self-expression, individuality and healthcare. And all these changes will generate demand for high-end elaborate sportswear.'
        ]
    },
    midpart2: { // 板式B布局，需添加更多板式A/B的文案可添加midpart4、5……,在双斜杠后备注采用板式A或B
        title: [
            '运动服饰在会员营销上需要三要素：品牌理念、场景运营和精准定价',
            'In terms of sportswear, three elements are required in member marketing: brand concept, scenario-based operation and precision pricing.'
        ],
        content: [
            '定价决定了市场规模。随着消费的分裂分层越来越严重，面对新一批有消费能力的消费者，成长的环境、经历的时代和经济的变化决定了他们的消费选择。新一代的运动品牌需要更长远、持续、和探讨人与自然及生命意义更相关的品牌理念来迎合新的消费环境，在落地方面要寻找空白的价格区间、场景化的互动，以及线下线上的运动场景相结合的运营方式。',
            'It is the pricing that determines the market size. Under the contemporary background where consumption is increasingly segmented and layered, the new generation of consumers with consuming ability are more likely to make their consumption choices in accordance with their growing environment, undergoing era and economic changes. In such circumstances, the new generation of sports brands is in greater need of a brand concept, which involves long-term consideration, sustainability, human-nature relationship and the exploration of the meaning of life, so as to cater to the new consumer environment. In terms of implementation, it is essential to find a blank within the price range, along with establishing an operation management approach to achieve scenario-based interaction and a combination of offline and online sports processes.'
        ]
    }
}
const retailText = {
    title: [
        '零售',
        'Retail'
    ],
    downtext: [
        '打造以用户为核心的线上线下服务模式',
        'Create a user-centric online and offline service model'
    ],
    subtitle: [
        '从传统线下商场开店的模式，转移到同时线上“开店”，根据鼎栈总结的方法论，需要在门店意识、工具和能力上有综合提升，才能使得线下门店具备驾驭私域运营成交的能力。',
        'From the traditional offline shopping mall store opening model, to the simultaneous online "store opening", according to the methodology summarized by Deansel, it is necessary to have a comprehensive improvement in store awareness, tools and capabilities, so that offline stores have the ability to control private domain operation transactions.'
    ],
    midpart1: {
        title: [ // 板式A布局
            '零售想要进化成新零售，就要让线上触达效能与线下一样高',
            'If retail wants to evolve into new retail, it must make online reach as high as offline'
        ],
        content: [
            '实现用户的全生命周期运营，联合线上线下，必然是个极大的挑战。对企业的数字化深度和灵活运用程度要求极高，并且也对人员管理和组织架构提出了新的挑战。但是，新品牌依靠其精简的人力、门店和创新的理念正高速地冲击着市场。如何让“大象”般的传统企业跳舞？如何快速响应市场变化从而实现模式创新？都成为对零售企业的新一轮考验。',
            'Realizing the whole life cycle operation of users and combining online and offline is bound to be a great challenge. The depth and flexibility of digitalization of enterprises is extremely demanding, and it also poses new challenges to personnel management and organizational structure. But new brands are impacting the market at a high rate with their streamlined workforce, stores and innovative ideas. How to make the "elephant" like traditional business dance? How to quickly respond to market changes to achieve model innovation? All have become a new round of tests for retail companies.'
        ]
    },
    midpart2: { // 板式B布局，需添加更多板式A/B的文案可添加midpart4、5……,在双斜杠后备注采用板式A或B
        title: [
            '私域模式的兴起，是对经销商模式的巨大考验',
            'The rise of the private domain model is a huge test of the dealer model'
        ],
        content: [
            '无论是赋能经销商还是探索DTC的自营模式，在本就瞬息万变的线下场景下，又增加了对线上能力的需求，这对大部分的经销商来说都是不小的考验。原本通过电商领先一步接触线上的企业已经开始做起了私域的流量生意，如何让地方性的经销商能够稳步和灵活地运用线上的方式，探索新的经营道路？品牌方又该如何推进和撬动整个市场的私域增长？唯有不断探索和快速响应市场变化的企业，方能生存。',
            'Whether it is empowering dealers or exploring DTC’s self-operated model, under the already rapidly changing offline scene, the demand for online capabilities has increased, which is a big test for most dealers. Enterprises that were originally one step ahead of e-commerce have begun to do private traffic business, how to enable local dealers to steadily and flexibly use online methods to explore new business paths? How can brands promote and leverage the private domain growth of the entire market? Only companies that are constantly exploring and responding quickly to market changes can survive.'
        ]
    },
    midpart3: {
        left: {
            title: [
                '咨询与培训：',
                'Consulting & Training:'
            ],
            content: [
                '市场与情报分析\n数字化战略定位\n私域战略咨询\n产品设计咨询\n私域赋能培训',
                'Market and intelligence analysis\n Digital strategic positioning\nPrivity strategic consulting\nProduct design consulting\nPrivate domain empowerment training'
            ]
        },
        right: {
            title: [
                '运营：',
                'Operation'
            ],
            content: [
                '品牌私域运营咨询\n私域日常代运营\n数据分析与私域优化运营',
                'Brand private domain operation consulting\nPrimary operation of private domain\n Data analysis and private domain optimization operation'
            ]
        }
    }
}
const tmallText = {
    downtext: [
        '疫情下的增长新场景',
        'A new scenario for growth under the epidemic'
    ],
    subtitle: [
        '今年是艰难的一年，新冠疫情的阴影尚笼罩在全体国民头顶，经济下行的惶恐又悄然而至。面对疫情和消费收紧带来的双重考验，线上消费更加成为企业之间争抢的必要渠道。',
        'This year has been a difficult year, the shadow of the coronavirus epidemic is still hanging over the heads of all the people, and the panic of the economic downturn has quietly arrived. In the face of the double test brought about by the epidemic and the tightening of consumption, online consumption has become a necessary channel for enterprises to compete.'
    ],
    midpart1: {
        title: [ // 板式A布局
            '新的时刻，必须以新的需求展开新的解决方案，创造更为直戳人心的场景内容',
            'In the new moment, we must develop new solutions with new requirements and create scene content that is more directly rooted in people’s hearts'
        ],
        content: [
            '为了包装“防晒新趋势”，我们构建了一个“未来防晒体验馆”的互动类H5，结合三个游戏推广“新趋势“，以未来科技感强化“新防晒”的概念。',
            'In order to package the "new sun protection trend", we built an interactive H5 of the "future sun protection experience hall", combined with three games to promote the "new trend", and strengthened the concept of "new sun protection" with a sense of futuristic technology.'
        ]
    },
    midpart2: { // 板式B布局，需添加更多板式A/B的文案可添加midpart4、5……,在双斜杠后备注采用板式A或B
        title: [
            '联动资源，多维度打造站内引流矩阵',
            'Linkage resources, multi-dimensional to create a drainage matrix in the station'
        ],
        content: [
            '在活动上线后3天，知乎热榜相关话题排行Top36 ，微博防晒搜索指数同比增幅700%。根据天猫国际反馈，这次活动创造了天猫国际IP活动的历史最高成交。成功孵化了Supergoop和RE:CIPE两家新店，打爆4个新防晒单品。其中，新开店商家Supergoop惊现千万级新品，爆卖7万多支。而战绩远不止销量，口碑声量也非常可观。',
            'Three days after the launch of the event, the topics related to the Zhihu hot list ranked top36, and the Weibo sunscreen search index increased by 700% year-on-year. According to Tmall international feedback, this event created the highest transaction in the history of Tmall international IP activities. Successfully incubated two new stores, Supergoop and RE:CIPE, and blew up 4 new sunscreen items. Among them, the newly opened store merchant Supergoop surprised ten millions of new products, selling more than 70,000 pieces. The record is far more than sales, and the word of mouth is also very impressive.'
        ]
    },
    midpart3: {
        left: {
            title: [
                '技术：',
                'Technology'
            ],
            content: [
                '产品基于千叶平台打造淘系内部的互动产品\n运用css动效低成本的增加用户体验\n',
                'The product is based on the Chiba platform to create interactive products within the Tao system\nUse css animation and low cost to increase the user experience\n'
            ]
        },
        right: {
            title: [
                '角色：',
                'Role'
            ],
            content: [
                '用户路径、产品设计 \nUI设计、交互设计 \n产品开发、联调上线 \n数据监控、持续优化',
                'User path, product design \nUI design, interaction design \n Product development, joint commissioning and on-line \nData monitoring, continuous optimization'            
            ]
        }
    },
    articles: [
        {
            from: [
                '广告门',
                'Advertisement door'
            ],
            title: [
                '天猫国际：未来防晒指南',
                'Tmall Global: future sun protection guide'
            ],
            url: 'https://creative.adquan.com/show/293387'
        }, // 鼠标悬浮上面要有个反馈的，链接是：https://creative.adquan.com/show/293387
        {
            from: [
                '天猫国际微博',
                'Tmall Global weibo'
            ],
            title: [
                '憋得发慌 终于见光',
                'Feeling suffocated, finally saw the light'
            ],
            url: 'https://weibo.com/u/5044759487?refer_flag=1001030103_'
        }, // 鼠标悬浮上面要有个反馈的，链接是：https://weibo.com/u/5044759487?refer_flag=1001030103_
        {
            from: [
                '天猫国际&凯度',
                'Tmall Global & Kantar '
            ],
            title: [
                '《解码中国消费者新防晒时代》',
                '< Decoding the New Sun Protection Era of Chinese Consumers >'
            ], // 鼠标悬浮上面要有个反馈的，链接是：https://www.kantarworldpanel.com/cn/publications/China-Insights
            url: 'https://www.kantarworldpanel.com/cn/publications/China-Insights'
        }
    ]
}
const peopleText = {
    title: [
        '这是一个因挑战而兴奋的团队',
        'This is a group of people who are excited by challenges'
    ],
    subtitle: [
        '我们骄傲于我们提供的产品和服务，并不是一味地遵循和实施合作伙伴的想法；而是把我们的经验、技术和能力应用在合作伙伴的商业场景中，并带来持久影响',
        'We are proud of the products and services we provide, not blindly following and implementing our partners’ideas; rather, we apply our experience, technology and capabilities to our partners’business scenarios and make a lasting impact'
    ],
    briefIntro: [
        '来自不同行业、背景的增长顾问们，将最前沿的行业洞察、最尖端的AI科技、最丰富的参考案例的和最切实的落地方案带给我们的合作伙伴，帮助他们在如今的快节奏中竞争，构建美好未来。',
        'Growth consultants from different industries and backgrounds bring the most cutting-edge industry insights, cutting-edge AI technology, the richest reference cases and the most practical landing solutions to our partners, helping them compete in today’s fast pace and build a better future.'
    ],
    subtitle2: [
        '我们的成员',
        'Our members'
    ],
    speciality: [
        {
            no: '01',
            icon: require('../assets/images/production.png'),
            content: [
                '产品大牛',
                ' Product Ace'
            ]
        },
        {
            no: '02',
            icon: require('../assets/images/programmer.png'),
            content: [
                '技术极客',
                'Technology Expert'
            ]
        },
        {
            no: '03',
            icon: require('../assets/images/operation.png'),
            content: [
                '运营精英',
                'Operation Specialist'
            ]
        },
        {
            no: '04',
            icon: require('../assets/images/designer.png'),
            content: [
                '设计天才',
                'Design Genius'
            ]
        }
    ],
    members: [
        {
            pos: [
                'CEO',
                'CEO'
            ],
            img: require('../assets/images/edward.jpg'),
            name: [
                '杨永康',
                'Edward Yang'
            ],
            intro: [
                '杨永康 Edward 他曾任职于美国知名咨询公司并负责互联网行业研究，杨先生作为咨询顾问曾多次参与多种类型的增长和咨询项目，拥有丰富的行业研究经验。创业以来，杨先生曾帮助各行业企业进行战略，产品咨询服务。他主要负责产品咨询，包括功能设计、产品定位，战略策划等。他不仅在战略咨询方面有多年的经验，之后更是把以用户为核心的产品概念拓展到模型化、市场化的新研究领域，并参与指导开发了超过50个互联网项目。',
                'Edward Yang  He has worked for a well-known consulting company in the United States and is responsible for Internet industry research, and Mr. Yang has participated in many types of growth and consulting projects as a consultant and has extensive industry research experience. Since his founding, Mr. Yang has helped enterprises in various industries to carry out strategic and product consulting services. He is mainly responsible for product consulting, including functional design, product positioning, strategic planning, etc. He not only has many years of experience in strategic consulting, but also expanded the user-centric product concept into new research areas of modeling and marketization, and participated in the development of more than 50 Internet projects.'
            ],
            img2: require('../assets/images/edward_live.jpg')
        },
        {
            pos: [
                'CTO',
                'CTO'
            ],
            img: require('../assets/images/nathan.jpg'),
            name: [
                '徐航',
                'Nathan Xu'
            ],
            intro: [
                '徐航 Nathan 曾任职于IBM和饿了么，担任研发总监，并同时负责多个营收项目。徐航负责系统开发和管理，并曾负责松下，三星等世界500强公司内部系统软件的开发。作为增长工程师，徐先生对系统的架构设计，搭建企业级SOA、大规模分布式架构有着独到的理解；同时，徐先生还对科技公司版本迭代，研发管理，项目生命周期管理有丰富经验。熟悉社交，物流，健康医疗，O2O等多个领域的技术服务，技术咨询和产品研发。',
                'Nathan Xu   He has worked at IBM and Ele.me as Director of Research and Development and was responsible for several revenue projects at the same time. Nathan Xu is responsible for system development and management, and has been responsible for the development of internal system software for Fortune 500 companies such as Panasonic and Samsung. As a growth engineer, Mr. Xu has a unique understanding of system architecture design, enterprise-level SOA construction, and large-scale distributed architecture, meanwhile, Mr. Xu also has rich experience in version iteration, R&D management, and project lifecycle management of technology companies. Familiar with social, logistics, health care, O2O and other fields of technical services, technical consulting and product development.'
            ],
            img2: require('../assets/images/nathan_live.jpeg')
        },
        {
            pos: [
                '增长顾问',
                'Growth consultant'
            ],
            img: require('../assets/images/andy.jpg'),
            name: [
                '郑彦民',
                'Andy Zheng'
            ],
            intro: [
                '郑彦民 Andy 主要通过数据分析与用户洞察为客户执行定制化的增长方案。Andy拥有一年的增长经理和三年的产品经理经验，对于多端产品开发有丰富的经验，精通电商平台的架构规划、使用者操作流程及增长营销模式，在台湾协助多家上市企业建构自己的电商平台。包括旺旺集团，DKSH，3M等。在上海规划执行日活超百万的工具型App的营销策略及增长策略。他熟悉产品架构规划、产品开发管理、产品数据分析及用户行为研究。',
                'Andy Zheng  Mainly through data analysis and user insights for customers to implement customized growth programs. With one year of experience as a growth manager and three years as a product manager, Andy has extensive experience in multi-terminal product development, proficient in the architectural planning, user operation process and growth marketing model of e-commerce platforms, and assisting a number of listed companies in Taiwan to build their own e-commerce platforms. Including Want-Want Group, DKSH, 3M, etc. In Shanghai, he plan and implement the marketing strategy and growth strategy of the tool-based app with more than one million daily active users. He is familiar with product architecture planning, product development management, product data analysis and user behavior research.'
            ],
            img2: require('../assets/images/andy_live2.jpeg')
        },
        {
            pos: [
                '增长顾问',
                'Growth consultant'
            ],
            img: require('../assets/images/sherry.jpg'),
            name: [
                '王文倩',
                'Sherry Wang'
            ],
            intro: [
                '王文倩 Sherry 负责用户-数据-产品设计的执行。她拥有三年的产品设计和创新服务经验，曾多次参与多种类型的设计咨询与产品开发项目。她熟悉设计/运营研究的基本流程和方法，对互联网产品开发和服务流程有深入理解。她善于应用设计和运营手段分析用户行为并进行充分调研，从而从交互、服务、流程等角度优化产品体验，从宣传策划、架构设计、功能实现等方面综合协调完成商业目标。',
                'Sherry Wang  Responsible for the execution of user-data-product design. She has three years of experience in product design and innovation services, and has been involved in various types of design consulting and product development projects. She is familiar with the basic processes and methods of design/operations research and has a deep understanding of the Internet product development and service process. She is good at applying design and operation methods to analyze user behavior and conduct full research, so as to optimize the product experience from the perspectives of interaction, service, process, etc., and comprehensively coordinate business goals from the aspects of publicity planning, architecture design, and function realization.'
            ],
            img2: require('../assets/images/sherry_live.jpg')
        },
        {
            pos: [
                '设计总监',
                'Design Director'
            ],
            img: require('../assets/images/jancy.jpg'),
            name: [
                '袁佳贤',
                'Jancy Yuan'
            ],
            intro: [
                '她拥有十余年的绘画经验，精通素描、水彩、水粉等各种绘画技巧，她以传统绘画的技法与美感结合新时代的行业，打破传统设计常规，独具一格。她有3年的设计经验和2年的项目经验，她很积极主动，善于把握创新灵感，能提炼复杂问题，提出简明的解决方案。她非常熟悉用户体验设计过程和技能，在日常工作中易于迭代、增量、持续和协作。同时她亦对设计充满热情，对用户体验（UX）和交互设计（IXD）有着热烈的追求。',
                'She has more than ten years of painting experience, proficient in drawing, watercolor, gouache and other painting techniques, she combines traditional painting techniques and aesthetics with the industry of the new era, breaking the traditional design conventions and is unique. With 3 years of design experience and 2 years of project experience, she is very proactive, good at grasping innovative inspiration, able to refine complex problems and propose concise solutions. She is intimately familiar with the UX design process and skills, and is easy to iterate, incremental, continuous, and collaborate on a daily basis. She is also passionate about design, with a passion for user experience (UX) and interaction design (IXD).'
            ],
            img2: require('../assets/images/jancy_live.jpg')
        },
        {
            pos: [
                '增长工程师',
                'Growth Engineer'
            ],
            img: require('../assets/images/qi.jpg'),
            name: [
                '郭奇',
                'Qi Guo'
            ],
            intro: [
                '郭奇精通Hadoop/Spark、Hive、HBase。曾多次主导多种类型的开发项目，负责用户行为分析、数据挖掘、算法设计等领域的产品架构,拥有丰富的数据处理与复杂业务的数据平台建设经验。他熟知机器学习算法LR、SVM、GBDT及原理、机器视觉，能根据项目需求进行算法模型的选择和开发。熟练运用深度学习基本模型，有多项算法性能优化、神经网络调参优化方面的项目经验。',
                'Qi Guo is proficient in Hadoop/Spark, Hive, and HBase. He has led many types of development projects, responsible for product architecture in the fields of user behavior analysis, data mining, algorithm design, etc., and has rich experience in data processing and data platform construction for complex business. He is familiar with machine learning algorithms LR, SVM, GBDT and principles, machine vision, and can select and develop algorithm models according to project requirements. Proficient in the basic model of deep learning, he has a number of project experience in algorithm performance optimization and neural network tuning parameter optimization.'
            ],
            img2: require('../assets/images/qi_live.jpg')
        },
        {
            pos: [
                '增长工程师',
                'Growth Engineer'
            ],
            img: require('../assets/images/chris.jpg'),
            name: [
                '刘雨晨',
                'Chris Liu'
            ],
            intro: [
                '他熟练掌握java语言、面向对象思想及常用设计模式，对开源框架如Spring、MyBatis等有深入的了解，熟练掌握MySql数据库及Redis、Nginx等开源中间件。了解项目的生命周期，具备复杂业务拆解能力，能够完成业务流程到技术架构的转化。参与技术难题攻关，持续提升核心系统在高并发、海量请求数下的高处理性能。在负责服务端研发以及数据库的设计和维护基础上，参与系统架构、应用架构和数据架构的规划、设计和评审，不断提高系统的扩展性、稳定性和安全性。',
                'He is proficient in java language, object-oriented thinking and common design patterns, has a deep understanding of open source frameworks such as Spring, MyBatis, etc., and is proficient in MySql databases and open source middleware such as Redis and Nginx. Understand the life cycle of the project, have the ability to dismantle complex businesses, and be able to complete the transformation of business processes into technical architectures. Participate in technical problem solving, and continuously improve the high processing performance of core systems under high concurrency and massive requests. On the basis of being responsible for the research and development of the service side and the design and maintenance of the database, participate in the planning, design and review of the system architecture, application architecture and data architecture, and continuously improve the scalability, stability and security of the system.'
            ],
            img2: require('../assets/images/k_live.jpg')
        },
        {
            pos: [
                '增长工程师',
                'Growth Engineer'
            ],
            img: require('../assets/images/mars.jpg'),
            name: [
                '马思雨',
                'Sylvia Ma'
            ],
            intro: [
                '她对W3C标准和标签语义化有深入理解，熟练掌握Javascript、DOM等前端技术，熟悉ECMA标准、webpack的基本配置，擅长组件模块化开发。她对MVC框架思想与MVVM设计模式有深刻理解，擅长PC端/移动端页面搭建与适配，能够运用bootstrap快速制作弹性或Web响应式页面。她曾多次使用Vue/React框架进行Web开发，并且拥有丰富的小程序开发经验。',
                'She has a deep understanding of W3C standards and tag semantics, is proficient in javascript, DOM and other front-end technologies, is familiar with the basic configuration of ECMA standards and webpack, and is good at component modular development. She has a deep understanding of MVC framework ideas and MVVM design patterns, is good at PC/mobile page building and adaptation, and can use bootstrap to quickly produce elastic or web responsive pages. She has used the Vue/React framework for web development many times and has extensive experience in mini program development.'
            ],
            img2: require('../assets/images/ma_live.jpg')
        }
    ]
}
const insightText = { //这里的标题文字悬浮跟麦肯锡的一样要变色下划线啥的,可以点击进入文章具体的页面，也是我们站内的
    title: [
        '阴云下的狂欢？疫情下跌宕起伏的线上流量战',
        'Carnival under the dark clouds? The online traffic war of the epidemic decline and ups and downs'
    ],
    articles1: [ // 第一行文章卡片
        {   //左第一行1
            img: require('../assets/images/insight_2.jpg'),
            title: [
                '创新产品：快速试错，加速成功',
                'Innovative products: Fast trial-and-error, accelerate success'
            ],
            content: [
                '通过将战略、社会科学和互联网技术相结合，把设计与创新融相融合并发现新的增长机会，从而促企业在其产业链上不断创新……',
                'By combining strategy, social science and Internet technology, integrating design and innovation and discovering new growth opportunities, companies are promoting continuous innovation in their industrial chains...'
            ],
            url: '',
            routerUrl: '/article5'
        },
        {   //左第一行2
            img: require('../assets/images/insight_3.jpg'),
            title: [
                '如何通过降低用户的决策成本获得增长？',
                'How can we grow by reducing the cost of user decisions?'
            ],
            content: [
                '从宏观的互联网环境变化到微观的每个用户，每个决策者，我们从而推演出用户决策增长模型……',
                'From the changes in the Internet environment at the macro level to every user and every decision maker at the micro level, we have deduced the user decision-making growth model...'
            ],
            url: 'https://mp.weixin.qq.com/s/2P5PRMru4-ZhPTLzQu1J8Q',
            routerUrl: ''
        },
        {   //左第二行
            img: require('../assets/images/insight_4.jpg'),
            title: [
                '一个被《人民日报》置顶的AI画展',
                'An AI painting exhibition that was topped by People’s Daily'
            ],
            content: [
                '4月22日，百度系APP开屏和百度doodle全天全量推送，人民日报APP在首页给栏位并在服务号文章置顶，陈赫、黄景瑜、杨紫和周冬雨四位明星在微博发声；截止4月23日零点，“野生动物映像馆”单日PV、UV、生成画作数均过百万……',
                'On The 22nd of July, Baidu sub-app Splash Ad and Baidu doodle open full volume push throughout the day, People’s Daily APP push on the home page and the official account article top, Chen He, Huang Jingyu, Yang Zi and Zhou Dongyu four stars on Weibo voice for that... As of 00:00 on April 23, the number of PV, UV, and generated paintings in a single day of the "Wildlife Image Museum" has exceeded one million. Of course, our biggest achievement is not this beautiful data, but the importance of protecting wildlife in millions of users.'
            ],
            url: '',
            routerUrl: '/article3'
        },
        {   //右
            img: require('../assets/images/tmall_1.jpg'),
            title: [
                '天猫国际未来防晒指南：疫情下的增长新场景',
                'Tmall Global Future Sun Protection Guide: New Scenarios for Growth under the Epidemic'
            ],
            content: [
                '今年是艰难的一年，新冠疫情的阴影尚笼罩在全体国民头顶，经济下行的惶恐又悄然而至。面对疫情和消费收紧带来的双重考验，线上消费更加成为企业之间争抢的必要渠道……',
                'This year has been a difficult year, the shadow of the coronavirus epidemic is still hanging over the heads of all the people, and the panic of the economic downturn has quietly arrived. In the face of the double test brought about by the epidemic and the tightening of consumption, online consumption has become a necessary channel for enterprises to compete.'
            ],
            url: '',
            routerUrl: '/article1'
        }
    ],
    element: [
        {
            title: [
                '国内增长黑客的践行者',
                'Practitioner of domestic growth hacking'
            ],
            img: require('../assets/images/element_1.png'),
            content: [
                '增长黑客在国内的落地一直存在着种种障碍，众多企业纷纷设立增长官职位来寻找流量后时代的破局点，Deansel作为最早的一批企业引入和落地增长黑客，在项目设计与实施上具有领先的行业经验。',
                'There have always been various obstacles to the landing of growth hackers in China, many companies have set up growth officer positions to find the breaking point of the post-traffic era, Deansel as the earliest batch of enterprises to introduce and land growth hackers, has leading industry experience in project design and implementation.'
            ]
        },
        {
            title: [
                '横跨移动互联网生态',
                'Across the mobile Internet ecosystem'
            ],
            img: require('../assets/images/element_2.png'),
            content: [
                'Deansel在微信生态下开发设计小程序、H5并结合私域流量与群运营设计完整的品牌增长链路；我们也为支付宝、淘宝、天猫提供淘系内的小程序和基于其内部平台的内容开发、设计和增长落地服务。',
                'Deansel develops and designs Mini Programs, H5 and combines private domain traffic and group operations to design complete brand growth links under the WeChat ecosystem; we also provide Alipay, Taobao and Tmall with Mini Programs within the Taobao system and content development, design and growth landing services based on their internal platforms.'
            ]
        },
        {
            title: [
                '服务20+细分行业领域',
                'Serve 20+ sub-industry segments'
            ],
            img: require('../assets/images/element_3.png'),
            content: [
                'Deansel服务于超过20个细分市场，分别属于互联网、社交电商、用户市场、非盈利和线上教育行业。在众多领域中寻找市场和用户的共通性和规律，为更多客户提供企业外部大脑和创新服务。',
                'Deansel serves more than 20 market segments, including the Internet, Social E-commerce, User Market, Non-Profit and Online Education industries. In many fields, we look for commonalities and laws of the market and users, and provide more customers with external brains and innovative services.'
            ]
        }
    ],
    articles2: [ // 第二行文章卡片
        {
            img: require('../assets/images/insight_5.jpg'),
            title: [
                '整理了近百个成功增长的案例，我们发现了增长的关键点',
                'After collating nearly 100 successful growth cases, we found the key points of growth'
            ],
            content: [
                '无论是用户增长还是收入增长，“增长”一直是所有企业最关注的主题。“站在巨人的肩膀上”，自己才能看得更高更远……',
                'Whether it’s user growth or revenue growth, "growth" has always been the most concerned theme for all businesses. "Standing on the shoulders of giants", you can see higher and farther...'
            ],
            url: 'https://mp.weixin.qq.com/s/Ha8TDvMoc5PEQjF6gsEmpg',
            routerUrl: ''
        },
        {
            img: require('../assets/images/insight_6.jpg'),
            title: [
                '合理应用动效，低成本优化用户体验',
                'Rational application of dynamic effects, low cost to optimize the user experience'
            ],
            content: [
                '在各类营销活动层出不穷的今天，如何夺得用户有限的注意力成为各家关注的焦点。在天猫国际防晒日项目中，我们进行了大量动效设计，尝试通过细腻的动效为用户提供动态沉浸式体验……',
                'In today’s endless marketing activities, how to win the limited attention of users has become the focus of attention of every family. In the Tmall International Sun Protection Day project, we carried out a large number of dynamic effect designs, trying to provide users with a dynamic immersive experience through delicate animation effects...'
            ],
            url: '',
            routerUrl: '/article2'
        },
        {
            img: require('../assets/images/insight_7.jpg'),
            title: [
                '用AI的力量，铸造社会的未来',
                'Use the power of AI to forge the future of society'
            ],
            content: [
                '微软2016 Build开发者大会上，“Seeing AI”首次公开亮相。该技术通过计算机视觉和自然语言处理来描述一个人的周边环境、朗读文本、回答问题……',
                'At Microsoft’s 2016 Build Developer Conference, "Seeing AI" made its public debut. The technology uses computer vision and natural language processing to describe a person’s surroundings, read text aloud, answer questions...'
            ],
            url: '',
            routerUrl: '/article4'
        },
        {
            img: require('../assets/images/insight_8.jpg'),
            title: [
                '阴云下的狂欢？疫情下跌宕起伏的线上流量战',
                'Carnival under the dark clouds? The online traffic war of the epidemic decline and ups and downs'
            ],
            content: [
                '过去是平台的黄金时代，线上红利的存在使得能够满足C端用户需求的平台产品层出不穷，社交，电商，团购，出行，内容。平台通过聚合链接双方需求迅速聚集起大量流量……',
                'In the past, it was the golden age of the platform, and the existence of online dividends made the platform products that can meet the needs of C-end users emerge in an endless stream, social, e-commerce, group buying, travel, and content. The platform quickly gathers a large amount of traffic by aggregating the needs of both sides of the link...'
            ],
            url: 'https://mp.weixin.qq.com/s/w2kxG0lnt0FH9v8sGPI3SQ',
            routerUrl: ''
        }
    ]
}
const socialText = {
    title: [
        '让科技变得有温度',
        'Let technology become warm'
    ],
    midpart1: {
        title: [
            '为逝去的野生动物作画',
            'Painting for dead wildlife'
        ],
        words: [
            {
                title: [
                    'AI作画',
                    'AI Painting'
                ]
            },
            {
                title: [
                    '百万用户参与',
                    'MIllions of users participate'
                ]
            },
            {
                title: [
                    'IFAW',
                    'IFAW'
                ]
            },
            {
                title: [
                    '人民日报嘉奖',
                    ' Awarded by People’s Daily '
                ]
            }
        ],
        articles: [
            {
                from: [
                    '来源：数英网',
                    'Source: Digitaling'
                ],
                title: [
                    '进入「野生动物映像馆」，用AI为逝去的动物作画',
                    'Enter the "Wildlife Mirror" and use AI to paint dead animals'
                ],
                url: 'https://www.digitaling.com/projects/111747.html'
            },
            {
                from: [
                    '来源：中国日报',
                    'Source: China Daily'
                ],
                title: [
                    '百度联合IFAW推全球首个“濒危物种AI守护官“，已筛查近25万图片信息',
                    'Baidu and IFAW launched the world’s first "endangered species AI guardian officer", which has screened nearly 250,000 picture information'
                ],
                url: 'https://tech.chinadaily.com.cn/a/202004/22/WS5e9ff4dca310c00b73c78dfc.html'
            } //这里只有俩个文章，剧中排版一下吧
        ]
    },
    midpart2: {
        title: [
            '千里传音',
            'voice transfer through thousand miles'
        ],
        words: [
            {
                title: [
                    '留守儿童',
                    'Left-behind children'
                ]
            },
            {
                title: [
                    '语音学习',
                    ' Voice Learning'
                ]
            },
            {
                title: [
                    '腾讯语音',
                    'Tencent Voice'
                ]
            },
            {
                title: [
                    '微粒贷',
                    'Weilidai'
                ]
            }
        ],
        articles: [
            {
                from: [
                    '来源：新华社',
                    'Source: NCNA'
                ],
                title: [
                    '当心愿能逐一实现时，你最想改变什么',
                    'When your wishes can be fulfilled one by one, what you most want to change'
                ],
                url: 'https://posts.careerengine.us/p/5b25e7e1b3fc1a380cd25d62'
            },
            {
                from: [
                    '虎嗅网',
                    'Huxiu'
                ],
                title: [
                    '你有多久没有听到父亲的声音了',
                    'It’s been a long time since you heard your father’s voice last time'
                ],
                url: 'http://kuaibao.qq.com/s/20180617A1FOPB00?refer=spider'
            },
            {
                from: [
                    '来源：knowyourself',
                    'Source：knowyourself'
                ],
                title: [
                    '看起来有多高冷，内心里就有多痴迷',
                    'How cold fish it seems, how obsessive it is in the heart'
                ],
                url: 'https://www.sohu.com/a/236438176_643443?_f=index_chan12news_22'
            }
        ]
    },
    midpart3: {
        title: [
            '以法律之名，让象牙不再是商品',
            'In the name of the law, ivory is no longer a commodity'
        ],
        words: [
            {
                title: [
                    '野生救援',
                    'WildAid'
                ]
            },
            {
                title: [
                    '象牙禁令',
                    'Ivory ban'
                ]
            },
            {
                title: [
                    '千万曝光',
                    'Ten millions of exposures'
                ]
            }
        ],
        articles: [
            {
                from: [
                    '来源：腾讯新闻',
                    'Source: Tencent News'
                ],
                title: [
                    '姚明：以法律之名，让象牙不再是商品',
                    'Ming Yao: In the name of the law, ivory is no longer a commodity'
                ],
                url: 'https://xw.qq.com/cmsid/20171230C08SN700'
            },
            {
                from: [
                    '来源：野生救援',
                    'Source: WildAid'
                ],
                title: [
                    '中国全面禁贸象牙在即，姚明呼吁公众勿触犯法律',
                    'With a total ban on ivory in China, Yao ming called on the public not to break the law'
                ],
                url: 'https://wildaidchina.org/%E4%B8%AD%E5%9B%BD%E5%85%A8%E9%9D%A2%E7%A6%81%E8%B4%B8%E8%B1%A1%E7%89%99%E5%9C%A8%E5%8D%B3%EF%BC%8C%E5%A7%9A%E6%98%8E%E5%91%BC%E5%90%81%E5%85%AC%E4%BC%97%E5%8B%BF%E8%A7%A6%E7%8A%AF%E6%B3%95%E5%BE%8B/'
            },
            {
                from: [
                    '来源：央视网',
                    'Source: CCTV.com'
                ],
                title: [
                    '警告！从现在起，买卖这东西违法！',
                    'Warn! From now on, it is illegal to buy and sell this thing!'
                ],
                url: 'http://m.news.cctv.com/2018/01/01/ARTI7WpbY90qGQmJ0kass59m180101.shtml'
            }
        ]
    },
    midpart4: {
        title: [
            '能力越大，责任越大',
            'The greater the ability, the greater the responsibility'
        ],
        content: [
            '技术也可以有温度，是我们在不断探索新商业模式时坚持的原则；置身于公益事业，联合伙伴企业和客户共同创造环保、人文、保护野生动物等的实际行动，赋予了Deansel新的生命力。我们也坚信，一家能够制造辉煌并成为历史一部分的品牌，一定是在发展中不断寻找自身的社会价值，承担应有的社会责任。',
            'Technology can also have a temperature, which is the principle we adhere to when constantly exploring new business models; in the public welfare undertakings, joint partner enterprises and customers to create environmental protection, humanities, wildlife protection and other practical actions, giving Deansel new vitality. We also firmly believe that a brand that can create brilliance and become a part of history must constantly find its own social value in the process of development and assume its due social responsibility.'
        ]
    }
}
const articleText1 = {
    title: [
        '天猫国际未来防晒指南：疫情下的增长新场景',
        'Tmall Global’s Guide to Sun Protection in the Future: New Scenarios for Growth under the Epidemic'
    ],
    subtitle: [
        '副标题字号36px，字距2.5，行高54，思源黑体粗体，54字以内，文章副标题文章副标题文章副标题文章副标题文章副标题',
        'Subtitle font size 36px, kerning 2.5, line height 54, Siyuan bold, within 54 characters, article subtitle??'
    ],
    from_logo: '',
    from: [
        '来源：Deansel',
        'Souce: Deansel'
    ],
    img1: require('../assets/images/demo.png'),
    content1: [
        '今年是艰难的一年，新冠疫情的阴影尚笼罩在全体国民头顶，经济下行的惶恐又悄然而至。面对疫情和消费收紧带来的双重考验，线上消费更加成为企业之间争抢的必要渠道。\n\n然而，线上消费在当下已然是一块被开垦殆尽的沃土，尽管有着巨大的存量，但将流量转化为购买力仍是一个不小的难题。如何在被瓜分后封闭起来的消费生态中唤起流量活性，可能是近期将持续延续的议题。\n\n可以看到，为了争抢有限的流动购买力，淘宝、京东、拼多多等电商平台先后以低价打造平台优势，1399的airpodspro、499的神仙水，甚至刚刚发布的ipadpro也在平台补贴下让利千元。在消费者纷纷“真香”的同时，我们也需要看到，尽管价格的优势对于消费者有着直接的吸引力，但补贴过后，曾经的低价未尝不是对品牌价格体系的伤害。更何况，大部分商家并没有头部平台破釜沉舟大幅让利的底气和能力。\n\n我们不妨将关注点重新聚焦到消费者身上，在价格没有大幅差异的前提下，消费者在对低单价消费品的购物中通常缺乏理性的判断比较，合理的刺激足以促使消费者完成消费过程。那么，如何制造这些合理的刺激呢？我们在“天猫国际防晒妙物日”项目中进行了一些摸索和尝试，事实证明，不需要大额让利，触及消费者“痒点”，同样可以做到增长。',
        'This year is a difficult year. The shadow of the new crown epidemic is still hanging over the heads of all the people, and the fear of economic downturn is coming quietly. In the face of the dual tests brought about by the epidemic and the tightening of consumption, online consumption has become an even more necessary channel for enterprises to compete. \n\nHowever, online consumption is already a fertile land that has been cultivated. Although there is a huge stock, it is still a big problem to convert traffic into purchasing power. How to evoke traffic activity in the closed consumer ecology after being divided may be a topic that will continue in the near future. \n\nIt can be seen that in order to compete for limited mobile purchasing power, Taobao, JD.com, Pinduoduo and other e-commerce platforms have successively created platform advantages at low prices. 1399 airpodspro, 499 fairy water, and even the just-released ipadpro are also Under the subsidy of the platform, the profit is 1,000 yuan. At the same time that consumers are "really fragrant", we also need to see that although the price advantage is directly attractive to consumers, after the subsidy, the once low price is not a harm to the brand price system. What’s more, most merchants do not have the confidence and ability to make substantial profits from the top platform. \n\nWe might as well refocus our attention on consumers. On the premise that there is no significant price difference, consumers usually lack rational judgment and comparison when shopping for low-unit price consumer goods. Reasonable incentives are enough to prompt consumers to complete consumption process. So, how to create these reasonable stimuli? We have made some explorations and attempts in the "Tmall International Sunscreen Wonderful Day" project. It has been proved that growth can also be achieved without the need for large profits and touching the "itch point" of consumers.'
    ],
    title2_1: [
        '1.讲好故事: 为消费者打造疫情阴霾下的浪漫幻想',
        '1. Tell good stories: Create romantic fantasy for consumers under the haze of the epidemic'
    ],
    content2: [
        '防晒作为一种成熟的护肤品类，在消费者心中有着较为固定的使用场景，户外、运动等不同时段的情境能够让消费者自动带入“防晒”需求，从而产生共鸣。但在居家隔离、休闲娱乐尚未全面开放的当下，这些场景对消费者来说就有些不合时宜了。\n\n新的时刻，必须以新的需求展开新的解决方案，创造更为直戳人心的场景内容。在对消费者的日常动线进行分析后，我们抓住了“室内抗蓝光”作为此次防晒品类推广的核心要素，结合“养肤防晒”和“彩妆搭档”作为2020防晒季的三大“新趋势”，以室内活动作为营销的新场景。为了包装“防晒新趋势”，我们构建了一个“未来防晒体验馆”的互动类H5，结合三个游戏推广“新趋势“，以未来科技感强化“新防晒”的概念。',
        'As a mature skin care category, sunscreen has a relatively fixed usage scenario in the minds of consumers. Different time periods such as outdoor and sports can allow consumers to automatically bring in the need for "sunscreen", thus resonating. However, at a time when home isolation and leisure and entertainment have not yet been fully opened, these scenarios are a bit out of date for consumers. \n\nIn the new moment, new solutions must be developed with new requirements to create more directly touching scene content. After analyzing the daily movements of consumers, we have seized "indoor anti-blue light" as the core element of the promotion of this sunscreen category, and combined "skin nourishing sunscreen" and "makeup partner" as the three major "anti-blue light" in the 2020 sunscreen season. New Trends", taking indoor events as a new marketing scenario. In order to package the "new trend of sun protection", we built an interactive class H5 of "future sun protection experience hall", combined with three games to promote "new trend", and strengthened the concept of "new sun protection" with a sense of future technology.'
    ],
    img2: require('../assets/images/tmall_1.jpg'),
    title3_1: [
        '立意浮于星空',
        'Floating in the starsky'
    ],
    content3: [
        '这个h5的发生场景设定在太空之中。经过小范围的关键词研究，我们发现，太空不仅能够让用户联想到“未来”、“高科技”、“科幻感”等关键词，也能够扩散到“辐射”、“光老化”等与防晒强相关的概念。这个富有联想性的场景具有衍生互动的多重可能，很符合作为“防晒新趋势”的衍生场景，又具有脱离现实的浪漫意味——一个漂浮在漫漫星海中的太空站，用户将在这里获得来自未来的防晒趋势咨讯。',
        'The scene of this h5 is set in space. After a small-scale keyword research, we found that space can not only remind users of keywords such as "future", "high-tech", and "sci-fi", but also spread to "radiation", "photoaging" and sun protection. Strongly related concepts. This associative scene has multiple possibilities of derivative interaction, which is in line with the derivative scene as a "new trend of sun protection", and has a romantic meaning out of reality - a space station floating in the starry sea, where users will get from Information on future sun protection trends.'

    ],
    img3: require('../assets/images/article1_1.jpg'),
    content4: [
        '由于此次推广的防晒产品主打新技术、专业性，我们先后考虑过“光辐射预防控制中心”、“光辐射研究所”、“全能防晒研究所”、“防晒协会太空营业厅”等名字作为h5主题，以向用户传达此次推广产品的科技感。但对于消费者来说，单一的概念灌输不仅理解成本高，过于“硬核”的名字也增加了劝退的可能。最后，我们选择了”未来防晒体验馆“，强调体验，将概念融于互动中，让用户在参与h5互动的过程中，潜移默化地接受品牌设定。',
        'Since the sunscreen products promoted this time feature new technology and professionalism, we have successively considered names such as "Optical Radiation Prevention and Control Center", "Optical Radiation Research Institute", "Almighty Sunscreen Research Institute", "Sunscreen Association Space Business Hall" and so on. h5 theme to convey the technological sense of this promotion to users. But for consumers, a single concept instillation is not only costly to understand, but too "hard-core" names also increase the possibility of persuading them to quit. Finally, we chose the "Future Sunscreen Experience Pavilion", emphasizing the experience, integrating the concept into the interaction, allowing users to subtly accept the brand setting in the process of participating in the h5 interaction.'
    ],
    title3_2: [
        '体验触及现实',
        'Experience touches reality'
    ],
    content5: [
        '“未来防晒体验馆”h5中分为三个互动场景来传达三种新型防晒趋势，用户在体验馆中经过三个游戏来加强对防晒概念的认知，最终成功晋级为“高段位防晒玩家”。在这种情感引导和激励下，用户处于统一的叙事空间中，更积极地完成互动行为。\n\n考虑到消费者疫情期间足不出户的痛点，”未来防晒体验馆“设计上采用了真实感较强的拟物化设计风格，以第一人称视角强化沉浸感，力图给用户营造一种更具有实景感的使用体验，从而模拟线下逛展的感觉。',
        '"Future Sunscreen Experience Hall" H5 is divided into three interactive scenes to convey three new sunscreen trends. Users play three games in the experience hall to strengthen their understanding of the concept of sunscreen, and finally successfully promoted to "high-level sunscreen player" . Under this emotional guidance and motivation, users are in a unified narrative space and more actively complete interactive behaviors. \n\nConsidering the pain points of consumers staying at home during the epidemic, the design of the "Future Sunscreen Experience Pavilion" adopts a more realistic quasi-object design style, strengthens the sense of immersion from the first-person perspective, and strives to create a sense of immersion for users. A more realistic user experience, so as to simulate the feeling of visiting the exhibition offline.'
    ],
    title2_2: [
        '2.优化链路：将概念融于交互体验',
        '2. Optimize the link: integrate the concept into the interactive experience'
    ],
    content6: [
        '为了传达“室内抗蓝光、“养肤防晒”和“彩妆搭档”三种防晒趋势，“未来防晒体验馆”分为三个游戏场景：“宇宙蓝光危机舱”、“未来养肤实验室”、“全息妆感体验间”通过游戏的方式对防晒新趋势进行了阐释。用户点击首页入口进入游戏，完成三个游戏互动后可以获得大额优惠券。',
        'In order to convey the three sun protection trends of "indoor anti-blue light," "skin nourishing sunscreen" and "makeup partner", "Future Sunscreen Experience Pavilion" is divided into three game scenes: "Cosmic Blue Light Crisis Cabin", "Future Skin Care Lab", The "Holographic Makeup Experience Room" explains the new trend of sun protection through games. Users click the homepage entry to enter the game, and after completing three game interactions, they can get a large coupon.'
    ],
    img4: require('../assets/images/article1_2.jpg'),
    content7: [
        '“宇宙蓝光危机舱”是一个限时找物游戏，用户需要在给定时间内找出室内产生蓝光的物品。\n\n蓝光对于大多数消费者来说是一个相对陌生的名词，我们选取常见的会散发蓝光的生活用品如台灯、电脑、手机等作为游戏元素，来进行这个概念的强化。用户在玩游戏的过程中会认知到，原来生活场景中处处都是蓝光源。游戏最后，还将通过文案强调蓝光危害进一步传达“室内抗蓝光”的理念，这时用户将获得针对蓝光防护的防晒产品推荐。',
        '"Cosmic Blue Light Crisis Pod" is a time-limited finder game where the user needs to find the items that generate blue light indoors within a given time. \n\nBlu-ray is a relatively unfamiliar term for most consumers. We choose common household items that emit blue light, such as desk lamps, computers, and mobile phones, as game elements to strengthen this concept. In the process of playing the game, users will realize that there are blue light sources everywhere in the original life scene. At the end of the game, the concept of “indoor anti-blue light” will be further conveyed by emphasizing blue light hazards through the copywriting, and users will receive sunscreen product recommendations for blue light protection.'
    ],
    img5: require('../assets/images/article1_3.jpg'),
    content8: [
        '“未来养肤实验室”以“量身定制”为创意点，将不同产品的特点拆分并结合到问题中，如“防晒同时你还想要什么养肤超能力？”最后根据用户的选择为用户推荐专属产品。',
        '"Future Skin Care Lab" takes "tailor-made" as the creative point, and splits and combines the characteristics of different products into questions, such as "What skin care superpowers do you want at the same time as sunscreen?" Finally, according to the user’s choice Recommend exclusive products for users.'
    ],
    img6: require('../assets/images/article1_4.jpg'),
    content9: [
        '“全息妆感体验间”采用了拼图作为游戏趣味点，“彩妆搭档”主推产品侧重对于彩妆的兼容性，希望加强用户对于防晒和化妆使用顺序的认知。为此，我们将妆前防晒和妆后防晒放在一套护肤+化妆流程中，设计制作了一张彩妆顺序图，引导用户完成拼图从而加深对妆前妆后防晒的概念理解。',
        'The "Holographic Makeup Experience Room" uses puzzles as the fun point of the game. The main products of "Makeup Partner" focus on the compatibility of color makeup, hoping to enhance users’ awareness of sunscreen and makeup application sequence. Post-sunscreen is placed in a set of skincare + makeup process, and a makeup sequence diagram is designed and produced to guide users to complete the puzzle to deepen the conceptual understanding of sunscreen before and after makeup.'
    ],
    img7: require('../assets/images/article1_5.jpg'),
    title2_3: [
        '3.联动资源，多维度打造站内引流矩阵',
        '3. Link resources to create a multi-dimensional traffic drainage matrix within the site'
    ],
    content10: [
        '在“天猫国际防晒妙物日”项目中，以线上互动h5作为此次活动站内和站外活动的承接点，在微博进行了h5链接的投放。同时，配合以“见光不怕晒”作为穹顶关键词，结合“高段位防晒”等话题联动微博、知乎等社交媒体资源展开内容讨论，形成“线上体验-内容种草发酵-站内购买”的推广链路。',
        'In the "Tmall International Sunscreen Wonderful Good Recommendation Day" project, the online interactive h5 was used as the undertaking point for the activities inside and outside the station, and the h5 link was launched on Weibo. At the same time, in conjunction with the dome keyword of "seeing the light without being afraid of the sun", combined with topics such as "high-level sunscreen", we linked Weibo, Zhihu and other social media resources to conduct content discussions to form "online experience-content planting and fermentation-site purchase" "Promotion link.'
    ],
    img8: require('../assets/images/article1_6.jpg'),
    content11: [
        '在活动上线后3天，知乎热榜相关话题排行Top36 ，微博防晒搜索指数同比增幅700%。根据天猫国际反馈，这次活动创造了天猫国际IP活动的历史最高成交。成功孵化了Supergoop和RE:CIPE两家新店，打爆4个新防晒单品。其中，新开店商家Supergoop惊现千万级新品，爆卖7万多支。而战绩远不止销量，口碑声量也非常可观。',
        'Three days after the event was launched, related topics on the Zhihu Hot List ranked Top 36, and the Weibo sunscreen search index increased by 700% year-on-year. According to the feedback from Tmall International, this event created the highest transaction in the history of Tmall International IP activities. Successfully hatched two new stores, Supergoop and RE:CIPE, and exploded 4 new sunscreen items. Among them, the newly opened store Supergoop has been surprised to find tens of millions of new products, and sold more than 70,000 pieces. And the record is far more than sales, and the volume of word of mouth is also very impressive.'
    ],
    img9: require('../assets/images/article1_7.jpg'),
    content12: [
        '可以看出，在疫情期间，看似一潭死水的流量池中仍然存在着可观的转化量。如果品牌能够急用户之所急、痛用户之所痛，真实地让利给用户，结合现有的线上资源，用少量投入就可能撬动大流量。\n\n尽管当下经济形势严峻，但这对诸多传统企业来说未必不是契机。线下营销全面取消，线上营销渐渐成为企业增长的核心点。在这个僵持的时刻，各个企业对流量红利愈加重视。这场流量的争夺或许才刚刚开始。',
        'It can be seen that during the epidemic, there is still a considerable amount of conversion in the seemingly stagnant flow pool. If the brand can be anxious about what users are worried about and what they are suffering from, and truly give benefits to users, combined with existing online resources, it is possible to leverage a large amount of traffic with a small amount of investment. \n\nAlthough the current economic situation is severe, this may not be an opportunity for many traditional enterprises. Offline marketing has been completely cancelled, and online marketing has gradually become the core point of corporate growth. At this stalemate, companies are paying more and more attention to traffic dividends. This competition for traffic may have just begun.'
    ]
}
const articleText2 = {
    title: [
        '合理应用动效，低成本优化用户体验',
        'Reasonable application of dynamic effects, optimized user experience at low cost'
    ],
    subtitle: [
        ''
    ],
    from_logo: '',
    from: [
        '来源：Deansel',
        'Source: Deansel'
    ],
    // img1: require('../assets/images/demo.png'),
    content1: [
        '在各类营销活动层出不穷的今天，如何夺得用户有限的注意力成为各家关注的焦点。在天猫国际防晒日项目中，我们进行了大量动效设计，尝试通过细腻的动效为用户提供动态沉浸式体验。\n\n由于站内环境限制，天猫国际防晒日h5“未来防晒馆”中很多原定的交互效果难以实现。为了弥补使用中交互体验的缺失，我们运用css加强了动态过程的表现，通过视觉反馈优化用户感知，帮助用户获得更加连贯、真实的使用体验。',
        'In today’s endless variety of marketing activities, how to win the limited attention of users has become the focus of attention. In the Tmall International Sunscreen Day project, we have carried out a large number of motion effects design, trying to provide users with a dynamic and immersive experience through delicate motion effects. \n\nDue to the environmental restrictions on the site, many of the planned interactive effects in the Tmall International Sunscreen Day h5 "Future Sunscreen Pavilion" are difficult to achieve. In order to make up for the lack of interactive experience in use, we use CSS to enhance the performance of the dynamic process, optimize user perception through visual feedback, and help users obtain a more coherent and realistic experience.'
    ],
    title2_1: [
        '加强故事性',
        'strengthen the story'
    ],
    content2: [
        '在未来防晒馆项目中，体验场景发生在一个太空空间站中。为了加强这种场景感，在进入游戏之前，我们制作了一个“太空远景”的动画，结合简单的点击引导动效和少量的文字，将用户拉进这个故事场景之中。\n\n用户观看动画的过程也是品牌形象的传达过程。天猫国际防晒日活动主打“高段位防晒产品”，品牌希望传达科技感、定制感。我们通过开场动画构建了一个场景从而烘托h5的氛围，更加立体地从感官上把信息传递给用户。',
        'In the future sunscreen project, the experience scene takes place in a space station. In order to strengthen this sense of scene, before entering the game, we created an animation of "space vision", combined with simple click-to-guide animation and a small amount of text, to pull the user into this story scene. \n\nThe process of users watching animations is also the process of communicating the brand image. The Tmall International Sunscreen Day event focuses on "high-end sunscreen products", and the brand hopes to convey a sense of technology and customization. We constructed a scene through the opening animation to enhance the atmosphere of h5, and convey the information to the user in a more three-dimensional sense.'
    ],
    img2: require('../assets/video/article2_1.mp4'),
    title2_2: [
        '增加沉浸感',
        'increase immersion'
    ],
    content3: [
        '如果仅仅是静态的图像，用户在使用中容易产生乏味感。而分析乏味感的来源不难发现，用户对与自己无关的事物很难有兴趣。因此天猫防晒日h5采用了第一人称的视角，从视觉上让用户获得置身其中的体验感。\n\n进入h5后的首页是一个太空舱舷窗作为主图，可以看见外部的星球，与开场动画进行衔接。在这里对外部的星球进行了小而精致的动效处理：舷窗外星轨缓缓而动，转向更深邃的宇宙深处。这些细微的处理，加强了h5的空间感和真实感，为用户营造出更富于沉浸感的视觉感知。',
        'If it is only a static image, the user is likely to feel boring in use. It is not difficult to find the source of boredom, and it is difficult for users to be interested in things that have nothing to do with them. Therefore, Tmall Sunscreen H5 adopts the first-person perspective, which visually allows users to gain a sense of experience in it. \n\nThe home page after entering h5 is a capsule porthole as the main image, you can see the outer planet, which is connected with the opening animation. Here, the outer planets are treated with small and delicate motion effects: the star trails outside the porthole move slowly, turning to the deeper depths of the universe. These subtle treatments enhance the sense of space and realism of the h5, creating a more immersive visual perception for users.'
    ],
    img3: require('../assets/video/article2_2.mp4'),
    title2_3: [
        '引导用户行为',
        'guide user behavior'
    ],
    content4: [
        '作为一个营销类h5，天猫国际未来防晒馆链路的最后一环是将用户引导至商品活动页。在不影响画面、不添加多余提醒的情况下，如何让用户主动关注到产品试图传达的链路呢？人类大脑和眼睛倾向于关注移动中的物体，我们选择了适当的动效帮助用户聚焦注意力，自然地引导用户进行相应行为。\n\n在天猫国际防晒日项目中，为了加强实景感，我们弱化了按钮处理，同时为了补偿用户的感知体验，在可触按钮上加了一个轻量的呼吸光晕效果。通过功能性动效帮助用户理解产品交互规则。',
        'As a marketing h5, the last link of the Tmall International Future Sunscreen Pavilion is to guide users to the product activity page. How to make users actively pay attention to the link that the product is trying to convey without affecting the screen and adding redundant reminders? The human brain and eyes tend to focus on moving objects, and we choose appropriate motion effects to help users focus their attention and naturally guide users to act accordingly. \n\nIn the Tmall International Sunscreen Day project, in order to enhance the sense of reality, we weakened the button processing. At the same time, in order to compensate the user’s perception experience, a light breathing halo effect was added to the touchable button. Help users understand the rules of product interaction through functional animation.'
    ],
    content5: [
        '根据天猫国际反馈，这次活动创造了天猫国际IP活动的历史最高成交，“未来防晒馆”h5也被称赞是近期“最有新意的营销概念”。复盘产品，css动效在体验优化中起到的作用是显著的；在产品交互上，css动效上又具有轻量流畅的优势。动效对于产品而言，不仅仅是锦上添花，甚至可能是点石成金。',
        'According to the feedback from Tmall International, this event created the highest transaction in the history of Tmall International IP activities, and the "Future Sunscreen Pavilion" h5 was also praised as the "most innovative marketing concept" recently. When reviewing products, css animation plays a significant role in experience optimization; in product interaction, css animation has the advantage of being lightweight and smooth. For a product, motion is not just the icing on the cake, it may even be a touch of gold.'
    ]
}
const articleText3 = {
    title: [
        '一个被《人民日报》置顶的AI画展',
        'An AI painting exhibition topped by People’s Daily'
    ],
    subtitle: [
        '副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题',
        'subtitle '
        
    ],
    from_logo: '',
    from: [
        '来源：Deansel',
        'Source: Deansel'
    ],
    img1: require('../assets/images/insight_4.jpg'),
    content1: [
        '4月22日，世界地球日，“野生动物映像馆”的上线引起广泛关注，用户可以用AI为逝去的动物作画。可能大家心中都会有一个疑问——AI是如何画出这些动物画作的？',
        'On April 22, Earth Day, the launch of the "Wild Animal Image Gallery" has attracted widespread attention. Users can use AI to draw pictures of dead animals. There may be a question in everyone’s mind - how does AI draw these animal paintings?'
    ],
    title2_1: [
        '技术原理',
        'Technical principle'
    ],
    content2: [
        '画馆中生成的画作经历了两步——deepdream和风格迁移，其中deepdream由百度飞桨完成，风格迁移由Deansel完成。',
        'The paintings generated in the gallery have undergone two steps—deepdream and style transfer. Deepdream is completed by PaddlePaddle, and style transfer is completed by Deansel.'
    ],
    title3_1: [
        '1.deepdream'
    ],
    content3: [
        '一个神经网络读入一张图片，通过多层网络，最后输出一个分类的结果。但是仅仅知道一个结果并不够，神经网络的一个挑战是要理解在每一层到底都发生了什么事。经过训练之后，每一层网络逐步提取越来越高级的图像特征，直到最后一层将这些特征比较做出分类的结果。比如前面几层也许在寻找边缘和拐角的特征，中间几层分析整体的轮廓特征，这样不断的增加层数就可以发展出越来越多的复杂特征，最后几层将这些特征要素组合起来形成完整的解释，这样到最后网络就会对非常复杂的东西，比如房子，小猫等图片有了反应。\n\n为了理解神经网络是如何学习的，必须要理解特征是如何被提取和识别的，如果分析一些特定层的输出，可以发现当它识别到了一些特定的模式，它就会将这些特征显著地增强，而且层数越高，识别的模式就越复杂。当分析这些神经元的时候，输入很多图片，然后去理解这些神经元到底检测出了什么特征是不现实的，因为很多特征人眼是很难识别的。一个更好的办法是将神经网络颠倒一下，不是输入一些图片去测试神经元提取的特征，而是选出一些神经元，看它能够模拟出最可能的图片是什么，将这些信息反向传回网络，每个神经元将会显示出它想增强的模式或者特征。经过反复迭代，并在每次迭代后进行缩放，也就是将图像的低频和高频特征进行细致划分，这样就能够不断激活特征，得到新效果。\n\n通过上面的过程会使神经网络在图片中产生一些本来不存在的东西，这也就产生了类似梦境和幻觉。',
        'A neural network reads in a picture, passes through a multi-layer network, and finally outputs a classification result. But knowing an outcome is not enough, a challenge for neural networks is to understand what is going on at each layer. After training, each layer of the network gradually extracts more and more advanced image features until the last layer compares these features to make a classification result. For example, the first few layers may be looking for the features of edges and corners, and the middle layers analyze the overall outline features, so that more and more complex features can be developed by increasing the number of layers, and the last layers combine these feature elements to form Complete explanations, so that by the end the network will react to very complex things like pictures of houses, kittens, etc. \n\nIn order to understand how the neural network learns, it is necessary to understand how the features are extracted and recognized. If you analyze the output of some specific layers, you can find that when it recognizes some specific patterns, it will use these features. significantly enhanced, and the higher the number of layers, the more complex the patterns identified. When analyzing these neurons, it is unrealistic to input many pictures and then understand what features are detected by these neurons, because many features are difficult to recognize by the human eye. A better way is to reverse the neural network. Instead of inputting some pictures to test the features extracted by the neurons, select some neurons, see what the most likely picture is, and pass this information back. Back in the network, each neuron will show the pattern or feature it wants to enhance. After repeated iterations and scaling after each iteration, that is, the low-frequency and high-frequency features of the image are carefully divided, so that the features can be continuously activated and new effects can be obtained. \n\nThrough the above process, the neural network will produce some things in the picture that do not exist, which will also produce similar dreams and hallucinations.'
    ],
    img2: require('../assets/images/article3_2.jpg'),
    title3_2: [
        '2.风格迁移',
        '2. Style transfer'
    ],
    content4: [
        '风格迁移是一个很有意思的任务，通过风格迁移可以使一张图片保持本身内容大致不变的情况下呈现出另外一张图片的风格。风格迁移领域发展路线主要有三个阶段：单内容单风格模型、任意内容单风格模型和任意内容任意风格模型。\n\n单内容单风格模型故名思义，就是对每一张内容图片和每一张风格图片，都需要单独建模，一般是对一张随机噪声图，不断地迭代优化，使生成图的风格近似于给定的风格图，内容却与给定的内容图像一致。任意内容单风格模型是对图像风格迁移网络进行训练，图像风格迁移网络一般是自编码器架构（AutoEncoder），输入任意一张内容图，模型可以直接输出风格化的图片。该类算法需要对一张特定风格图进行训练，在推理的时候，可以对任意内容进行风格化，但对每个风格都需要建模，如果有一千个风格图，就要训练一千个模型。任意内容任意风格模型，能够实现任意图像的风格化，Deansel使用的即是此模型。\n\n通过近8w张风格图和6k张纹理图训练的风格预测网络P，学习每个风格仿射变换参数得到向量S，然后将deepdream后的画作和向量S输入到风格迁移网络T，最终得到风格迁移后的画作。',
        'Style transfer is an interesting task. Through style transfer, a picture can be rendered with the style of another picture while keeping its own content roughly unchanged. The development route of style transfer field mainly has three stages: single content single style model, arbitrary content single style model and arbitrary content arbitrary style model. \n\nThe single-content single-style model, as the name suggests, requires separate modeling for each content image and each style image. Generally, a random noise image is continuously iteratively optimized to generate The style of the graph is similar to the given style graph, but the content is consistent with the given content image. The arbitrary content single style model is to train the image style transfer network. The image style transfer network is generally an autoencoder architecture (AutoEncoder). Input any content map, and the model can directly output stylized pictures. This type of algorithm needs to be trained on a specific style map. During inference, any content can be stylized, but each style needs to be modeled. If there are one thousand style maps, one thousand should be trained. Model. Arbitrary content and any style model, which can realize the stylization of any image, which is what Deansel uses. \n\nThrough the style prediction network P trained by nearly 8w style maps and 6k texture maps, learn each style affine transformation parameter to obtain the vector S, and then input the deepdream painting and vector S to the style transfer network T, Finally, a painting after style transfer is obtained.'
    ],
    img3: require('../assets/images/article3_3.jpg'),
    title2_2: [
        '执行过程',
        'Implementation process'
    ],
    content5: [
        '项目执行过程总体还算顺利，其中有两个点印象深刻。',
        'The project execution process was generally smooth, and there were two impressive points.'
    ],
    title3_3: [
        '1.前端适配',
        '1. Front-end adaptation'
    ],
    content6: [
        '“野生动物映像馆”因为资源量大，曝光量高，要适配非常多的端，手机百度、百度地图、百度网盘、人民日报、微信、微博……各种机型也要适配到，这对前端工程师无疑是一个很大的挑战。为了项目能如期上线，综合考虑业务和适配后，前端同学一共做了三个大版——百度系版、微信微博版和人民日报版，适配所有主流机型。“本来几天做一个版本，现在一天做八版”是前端同学对本次项目的评价，不出所料一直改到上线前一刻。',
        'Because of the large amount of resources and high exposure, "Wild Animal Image Gallery" needs to be adapted to a lot of terminals, such as mobile phone Baidu, Baidu Map, Baidu Netdisk, People’s Daily, WeChat, Weibo... Various models should also be adapted This is undoubtedly a big challenge for front-end engineers. In order to launch the project as scheduled, after comprehensively considering the business and adaptation, the front-end students made a total of three large editions—Baidu edition, WeChat Weibo edition and People’s Daily edition, which are suitable for all mainstream models. "I originally made one version in a few days, but now I make eight versions a day" is the evaluation of the front-end students on this project, which, as expected, has been changed until the moment before the launch.'
    ],
    title3_4: [
        '2.后端处理画作',
        '2. Back-end processing paintings'
    ],
    content7: [
        '为保证千人千面，给用户专属感，我们一共生成了百万张画作，根据用户选择的物种随机给到用户。处理画作的步骤大致是批量裁图、批量跑图、批量重命名和批量上传。首先将原图批量裁剪为海报需要的比例，其次将裁剪后的原图和挑选出的风格图进行风格迁移，再次将风格迁移后的画作批量重命名，最后将重命名后的画作批量上传至云对象存储。',
        'In order to ensure thousand-people-with-thousand-faces and give users a sense of exclusiveness, we have generated a total of millions of paintings and randomly distributed them to users according to the species selected by users. The steps for processing paintings are roughly batch cropping, batch running, batch renaming and batch uploading. First, batch crop the original images to the ratio required by the poster, then transfer the style of the cropped original images and the selected style images, rename the transferred paintings in batches, and finally upload the renamed paintings in batches to Cloud object storage.'
    ],
    title2_3: [
        '成绩',
        'score'
    ],
    content8: [
        '4月22日，百度系APP开屏和百度doodle全天全量推送，人民日报APP在首页给栏位并在服务号文章置顶，陈赫、黄景瑜、杨紫和周冬雨四位明星在微博发声……截止至4月23日零点，“野生动物映像馆”单日PV、UV、生成画作数均过百万。\n\n其实，Deansel最大的成绩不是这些漂亮的数据，而是让百万用户意识到保护野生动物。',
        'On The 22nd of July, Baidu sub-app Splash Ad and Baidu doodle open full volume push throughout the day, People’s Daily APP push on the home page and the official account article top, Chen He, Huang Jingyu, Yang Zi and Zhou Dongyu four stars on Weibo voice for that... As of 00:00 on April 23, the number of PV, UV, and generated paintings in a single day of the "Wildlife Image Museum" has exceeded one million. Of course, our biggest achievement is not this beautiful data, but the importance of protecting wildlife in millions of users.'
    ],
}
const articleText4 = {
    title: [
        '野生动物映像馆：AI helps human',
        'Wildlife Image Gallery: AI helps human'
    ],
    subtitle: [
        '副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题',
        'subtitle'
    ],
    from_logo: '',
    from: [
        '来源：Deansel',
        'Source: Deansel'
    ],
    content1: [
        '微软2016 Build开发者大会上，“Seeing AI”首次公开亮相。该技术通过计算机视觉和自然语言处理来描述一个人的周边环境、朗读文本、回答问题，甚至能够识别他人的面部表情。开发团队的盲人成员Taylor说，Seeing AI为依靠导盲手杖和导盲犬的视障人士提供了另一个层面的信息，“这款应用将有助于为视障人士营造更公平的环境。”2019年，微软公布了Seeing AI的一个新功能：用户可以通过触摸来“看”照片，使用者只要轻点照片，设备就会说出照片中的被摄对象及空间关系，让影像得以在用户脑中大致「重现」。',
        'At Microsoft’s 2016 Build developer conference, "Seeing AI" made its first public appearance. The technology uses computer vision and natural language processing to describe a person’s surroundings, read text aloud, answer questions, and even recognize other people’s facial expressions. Taylor, a blind member of the development team, said that Seeing AI provides another level of information for visually impaired people who rely on guide canes and guide dogs. "This app will help create a more equitable environment for visually impaired people." In 2019, Microsoft announced a new feature of Seeing AI: users can "see" photos by touching them. As long as the user taps the photo, the device will tell the subject and spatial relationship in the photo, so that the image can be displayed on the user’s screen. It is roughly "reproduced" in the brain.'
    ],
    img1: require('../assets/images/article4_1.jpg'),
    content2: [
        '疫情当下，AI的作用进一步被凸显，病毒分析与疫苗开发、诊断辅助、智能测温、智能电话……AI为人类对抗疫情贡献了强大的力量。AI无处不在，它还可以做更多事情。\n\n Deansel坚持“do not be evil”和“科技向善”的价值观，从创立以来就致力于参与AI+公益，体现社会责任感。\n\n乡村小学老师兰银香，想为乡村的留守儿童发明一款睡前故事音箱，Deansel联合微粒贷为兰老师找到了微信智聆团队与腾讯智能创新业务部一起合作，用端对端语音合成技术开发出可以模拟父亲声音讲故事的智能音箱，让远在他乡工作的父亲能用声音陪伴家乡孩子的成长。',
        'At the moment of the epidemic, the role of AI has been further highlighted. Virus analysis and vaccine development, diagnostic assistance, intelligent temperature measurement, smart phones... AI has contributed a powerful force to mankind’s fight against the epidemic. AI is everywhere, and it can do so much more. \n\n Deansel adheres to the values of "do not be evil" and "science and technology for good", and has been committed to participating in AI+ public welfare since its inception, reflecting a sense of social responsibility. \n\nLan Yinxiang, a rural primary school teacher, wanted to invent a bedtime story speaker for the left-behind children in the countryside. Deansel, together with Weiweidai, found the WeChat Zhiling team for Ms. Lan to cooperate with Tencent’s Smart Innovation Business Department. The terminal speech synthesis technology has developed a smart speaker that can simulate the father’s voice and tell stories, so that the father who works far away can use his voice to accompany the growth of his children in his hometown.'
    ],
    img2: require('../assets/images/article4_2.jpg'),
    content3: [
        '据调查，20%的致命事故与疲劳驾驶有关。Deansel参与百度Apollo疲劳驾驶监测系统项目，保障全国3000多万名货车司机的生命安全。',
        'According to the survey, 20% of fatal accidents are related to fatigue driving. Deansel participated in the Baidu Apollo fatigue driving monitoring system project to ensure the safety of more than 30 million truck drivers across the country.'
    ],
    img3: require('../assets/images/article4_3.jpg'),
    content4: [
        '中国有900多万阿尔茨海默病患者，Deansel联合F5为百度提供创意，运用人脸识别、声纹识别等技术为阿尔茨海默病患者开发了一副特殊的眼镜，此眼镜可以自动读取所视对象的外貌特征，通过细微的差异判断出身份，并用语音传递给患者。',
        'There are more than 9 million Alzheimer’s patients in China. Deansel and F5 provided ideas for Baidu, using face recognition, voiceprint recognition and other technologies to develop a pair of special glasses for Alzheimer’s patients. The glasses can automatically read Take the appearance characteristics of the object to be seen, determine the identity through subtle differences, and transmit it to the patient with voice.'
    ],
    img4: require('../assets/images/article4_4.jpg'),
    content5: [
        '4月22日，世界地球日，人民日报官微置顶了一则消息——“为逝去的野生动物作画”，点击后进入“野生动物映像馆”。',
        'On April 22, Earth Day, the official WeChat account of the People’s Daily put a message on the top - "Painting for the dead wild animals", click to enter the "Wild Animal Image Gallery".'
    ],
    img5: require('../assets/images/article4_5.jpg'),
    content6: [
        '“野生动物映像馆”是Deansel联合百度、国际爱护动物基金会（简称IFAW）、人民日报及知名创意机构F5，以保护野生动物为目的，为野生动物作画为载体，开发、执行的一个技术+艺术的数字项目。',
        '"Wild Animal Image Gallery" is a technology and artistic digital project developed and implemented by Deansel in conjunction with Baidu, the International Fund for Animal Welfare (IFAW), the People’s Daily and the well-known creative agency F5.  '
    ],
    img6: require('../assets/images/article4_6.jpg'),
    content7: [
        '画馆中，用户可以选择物种，和AI一起为它作画。',
        'In the gallery, users can choose a species and paint it with AI.'
    ],
    img7: require('../assets/images/article4_7.jpg'),
    content8: [
        '联合国环境署成立的政府间生物多样性和生态系统服务平台(IPBES)发布报告指出，目前全球物种灭绝的速度“至少比过去1000万年的平均速度快数十至数百倍”。每个生命都有存在的意义，保护野生动物是我们每个人的责任，画馆中触目惊心的动物故事警示我们，如果再继续冷眼旁观，我们的子孙后代就只能通过AI生成的画作来想象野生动物的样子，而无法目睹它们的真容。\n\n植物、动物、人和环境共同构成一个生物群落——生态系统，其中的各个部分唇齿相依，如果某个部分失衡或灭绝，整个系统都会受到影响，所以保护野生动物也是在保护人类自身。\n\n百度承诺，每作一幅画，飞桨将贡献10分钟AI算力（相当于12000条线索筛选），用于侦查筛选网络非法贸易线索。在野生动物映像馆中作画，就是在为保护野生动物贡献自己的一份力量。',
        'According to a report released by the Intergovernmental Platform on Biodiversity and Ecosystem Services (IPBES) established by the United Nations Environment Programme, the current rate of global species extinction is "at least tens to hundreds of times faster than the average rate of the past 10 million years". Every life has a meaning of existence, and it is the responsibility of each of us to protect wild animals. The shocking animal stories in the gallery warn us that if we continue to watch from the sidelines, our children and grandchildren can only imagine wild animals through AI-generated paintings look, and cannot see what they really are. \n\nPlants, animals, people and the environment together form a biological community - an ecosystem, each part of which is interdependent. If a part is out of balance or extinct, the entire system will be affected, so protecting wild animals is also protecting human beings themselves . \n\nBaidu promises that for each painting, PaddlePaddle will contribute 10 minutes of AI computing power (equivalent to 12,000 clues to screen), which will be used to detect and screen illegal trade clues on the Internet. To paint in the Wildlife Image Gallery is to contribute to the protection of wild animals.'
    ],
    img8: require('../assets/images/article4_8.jpg'),
    content9: [
        '最后，来“野生动物映像馆”，和Deansel一起打击野生动物非法贸易，保护野生动物。',
        'Finally, come to the "Wildlife Image Gallery" to fight against the illegal trade of wild animals and protect wild animals with Deansel.'
    ],
    qrcode: require('../assets/images/wildlife_qrcode.png')
}
const articleText5 = {
    title: [
        '创新产品案例：快速试错，加速成功——如何利用持续创新打造成功的商业模式',
        'Innovative Product Case: Fast Trial-and-Error, Accelerated Success - How to Leverage Continuous Innovation to Create a Successful Business Model'
    ],
    subtitle: [
        '副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题',
        'subtitle'
    ],
    from_logo: '',
    from: [
        '来源：Deansel',
        'Source: Deansel'
    ],
    title2_1: [
        '背景',
        'Background'
    ],
    content1: [
        '全世界露天倾倒的塑料垃圾有1/4在中国，一年两百万吨的外卖塑料垃圾，已经造成中国生态环境的大灾难。平均每天有2.56亿份外卖被送往用户手中，其中至少分别产生2.56亿个餐盒和塑料袋。在中国，外卖盒基本上不会得到回收利用。这些用过的塑料餐盒必须经过清洗才能回收利用，回收成本较大，而且由于餐盒太轻，收废品的人需要收集足够重量，才能卖给回收商。“费半天功夫挣几分钱，不值得。”\n\nW为世界前十强的美商公司，为了保护环境决定在中国启动一个小型（在特定办公商场）的能够重复循环利用外卖创新产品的实验。',
        'One-quarter of the plastic waste dumped in the open air in the world is in China, and 2 million tons of plastic waste from take-out a year has caused a catastrophe to China’s ecological environment. On average, 256 million takeaways are delivered to users every day, of which at least 256 million lunch boxes and plastic bags are generated. In China, takeaway boxes are rarely recycled. These used plastic lunch boxes must be cleaned before they can be recycled. The cost of recycling is high, and because the lunch boxes are too light, the waste collectors need to collect enough weight before they can be sold to recyclers. "It’s not worth it to spend half a day to earn a few cents."\n\nW As one of the top ten American companies in the world, in order to protect the environment, they decided to launch a small (in a specific office mall) in China that can recycle and reuse innovative food delivery products experiment of.'
    ],
    title2_2: [
        '与Deansel的邂逅',
        'Encounter with Deansel'
    ],
    content2: [
        'W在找到Deansel前，已经在美国找了一家强大的顾问及设计公司，对产品进行规划，并且做了一系列进入中国的准备。然而当产品实际要进入中国时却面临许多问题，美国的用户习惯跟中国是截然不同的。找到Deansel后，我们开始帮他们重新调整产品的布局及设计。在产品的设计方面，Deansel根据中国用户的使用习惯帮助W调整产品界面、运营及推广的策略，把产品的整个链路及流程重新规划，调整到最符合中国用户及中国市场的形态。\n\n我们先对产品的整体方案及策略进行优化，在这个过程中我们与远在纽约的客户经历了无数个颠倒的日夜开会讨论修改细节，按照最符合中国用户习惯的需求去设计产品，接着我们遵循0-1的模式，先制定产品需求表，再制作用户体验流程图、设计产品架构，画出产品原型，制定产品设计规范，照着这样的规划进入产品开发期。\n\n在产品开发的过程中，为加速产品的上线，节省开发的成本，我们定义了产品MPV，找出最符合产品的功能去做重点规划，把其他次要功能列入产品的迭代计划中。在这样的产品中，除了用户端，我们还需要开发管理后台、餐厅POS系统及可视化数据后台。我们需要在一个半月内将这个产品开发完成。\n\n与此同时，我们还需要规划实际落地之后的细节，包括试验场地的找寻、人员的招聘、餐厅的洽谈、餐厅的培训、市场营销的预算和运营活动的规划。\n\n关于试验场地，我们找到了位于上海市中心的商业复合式办公商场，该商场汇聚的常驻办公人数规模大约有10000人，因此我们选择在这里试验该商业模式。\n\n在试验开始后我们为该产品设计了一系列线上及线下的拉新活动，定制了内容营销的策略，帮助该产品取得了接近8成的用户。同时，我们对每日的工作流程进行优化，结合数据分析，来优化整体产品、营销活动和运营流程。Deansel还承担了财务相关的工作，包含财务的支出、餐厅收入的对帐及汇款，帮助大型跨国企业在繁琐的流程中节省时间成本。\n\nDeansel通过实际的数据透视验证该产品的可行性，完成了一个从0-1的产品，运用创业的模式，去落地指导一家传统的大型跨国企业完成创新项目。',
        'Before W found Deansel, he had already found a strong consultant and design company in the United States, planned the product, and made a series of preparations for entering China. However, when the products actually enter China, they face many problems, and the user habits in the United States are completely different from those in China. After we found Deansel, we started to help them redesign the layout and design of the product. In terms of product design, Deansel helps W adjust the product interface, operation and promotion strategies according to the usage habits of Chinese users, and re-plans the entire link and process of the product to adjust it to the most suitable form for Chinese users and the Chinese market. \n\nWe first optimize the overall plan and strategy of the product. During this process, we have experienced countless upside-down day and night meetings with customers in New York to discuss and modify the details, and design products according to the needs of Chinese users. , and then we follow the 0-1 model, first formulate the product requirement table, then make the user experience flow chart, design the product architecture, draw the product prototype, formulate the product design specification, and enter the product development period according to this plan. \n\nIn the process of product development, in order to accelerate the launch of the product and save the development cost, we define the product MPV, find out the functions that best match the product, make key planning, and include other secondary functions in the product iteration intend. In such a product, in addition to the user end, we also need to develop the management backend, restaurant POS system and visual data backend. We need to develop this product within a month and a half. \n\nAt the same time, we also need to plan the details after the actual landing, including the search for the test site, the recruitment of personnel, the negotiation of the restaurant, the training of the restaurant, the marketing budget and the planning of the operation activities. \n\nAs for the test site, we found a commercial complex office mall in the center of Shanghai. The number of resident office workers in this mall is about 10,000, so we chose to test the business model here. \n\nAfter the start of the experiment, we designed a series of online and offline new promotion activities for the product, customized content marketing strategies, and helped the product gain nearly 80% of users. At the same time, we optimize the daily workflow, combined with data analysis, to optimize the overall product, marketing activities and operational processes. Deansel also undertakes financial-related work, including financial expenditures, reconciliation of restaurant income and remittances, helping large multinational companies save time and cost in tedious processes. \n\nDeansel verified the feasibility of the product through actual data perspective, completed a 0-1 product, and used the entrepreneurial model to guide a traditional large multinational enterprise to complete an innovative project.'
    ],
    title2_3: [
        '在这6个月内Deansel协助W完成了：',
        'During these 6 months Deansel assisted W to complete:'
    ],
    title3_1: [
        '1.整体方案及策略的优化调整',
        '1. Optimization and adjustment of the overall plan and strategy'
    ],
    title4_1: [
        'A.首先重新设计符合中国用户使用习惯的产品Wireframe',
        'A. First redesign the product Wireframe that conforms to the usage habits of Chinese users'
    ],
    content3: [
        '原先美国团队设计的wireframe风格是比较像Uber Eats的，经过我们专业地调整，既保留了客户想要的简洁风格，又符合中国用户的习惯，以此达到双赢。',
        'The wireframe style originally designed by the American team is more like Uber Eats. After our professional adjustment, it not only retains the concise style that customers want, but also conforms to the habits of Chinese users, so as to achieve a win-win situation.'
    ],
    img1: require('../assets/images/article5_1.jpg'),
    desc1: [
        '客户端小程序Wireframe',
        'Client applet Wireframe'
    ],
    img2: require('../assets/images/article5_2.jpg'),
    desc2: [
        '餐厅Pos系统Wireframe',
        'Restaurant Pos System Wireframe'
    ],
    title4_2: [
        'B.制作用户及产品的流程动向图',
        'B. Make a flow chart of users and products'
    ],
    content4: [
        '制作出用户及产品的流程动向图，标记出每个关键的节点，去更深入地找出产品可能面临的问题，确立产品的核心功能，并且找出需要线下人力配合的节点，进一步规划出整体的运营计划。搭配产品Wireframe可以更有效地规划出符合整个用户生命周期的产品功能。',
        'Make a flow chart of users and products, mark each key node, find out the problems that the product may face, establish the core functions of the product, and find out the nodes that need offline human cooperation, and further plan out Overall operating plan. Paired with the product Wireframe, product features that fit the entire user life cycle can be more effectively planned.'
    ],
    img3: require('../assets/images/article5_3.jpg'),
    desc3: [
        '客户端小程序Wireframe',
        'Client applet Wireframe'
    ],
    img4: require('../assets/images/article5_4.jpg'),
    desc4: [
        '餐厅Pos系统Wireframe',
        'Restaurant Pos System Wireframe'
    ],
    title4_3: [
        'C.敏捷开发流程制定产品MPV',
        'C. Agile development process to formulate product MPV'
    ],
    content5: [
        '针对该案例，在短短的一个半月内，Deansel要完成三个操作端（用户、餐厅、阿姨回收）的开发，而在产品设计之初规划了很多庞大的功能，这就需要我们权衡这些功能的重要性，找到符合最大效益的核心功能去开发。Deansel凭借着专业的产品开发经验，制作出产品MPV并找出了符合产品的核心功能，规划了一个符合上线需求又不会让客户觉得简陋的产品。',
        'In response to this case, in just one and a half months, Deansel had to complete the development of three operation terminals (user, restaurant, and aunt recycling), and planned a lot of huge functions at the beginning of product design, which requires us to weigh these functions. The importance of finding the core functions that meet the greatest benefits to develop. With professional product development experience, Deansel produced a product MPV and found out the core functions that meet the product, and planned a product that meets the online needs without making customers feel crude.'
    ],
    img5: require('../assets/images/article5_5.jpg'),
    desc5: [
        '产品MPV功能表',
        'Product MPV function table'
    ],
    title4_4: [
        'D.罗列出整体的市场计划及财务预算',
        'D. List the overall market plan and financial budget'
    ],
    content6: [
        '详细规划出所有市场费用及运营费用，确保成本及预算是可控的，并且可以预先掌握风险。',
        'All marketing and operating expenses are planned in detail to ensure that costs and budgets are controllable, and risks can be grasped in advance.'
    ],
    img6: require('../assets/images/article5_6.jpg'),
    desc6: [
        '市场预算规划表',
        'market budget plan'
    ],
    title4_5: [
        'E.执行时需要的合作厂商提供',
        'E. Provided by cooperative manufacturers required for implementation'
    ],
    content7: [
        'Deansel拥有庞大的产业矩阵关系，从互联网到人力都可以为客户提供相应的厂商。本案例所需要的回收餐盒及清洁的阿姨，运餐盒用送的运货员，都由Deansel协助找寻。',
        'Deansel has a huge industry matrix relationship, and can provide customers with corresponding manufacturers from the Internet to manpower. Deansel assisted in finding the recycled lunch boxes and cleaning aunts needed in this case, as well as the delivery man who delivered the lunch boxes.'
    ],
    title3_2: [
        '2.产品开发',
        '2. Product development'
    ],
    title4_6: [
        'A.规范及设计产品的icon、颜色等等',
        'A. Standardize and design the icon, color, etc. of the product'
    ],
    content8: [
        '为了让所有涉及开发的人员清楚产品规范，在开发前期我们已制定好完整的产品设计规范，由此降低开发时出错的概率，准时地在最短的时间内完成开发的工作。',
        'In order to make the product specification clear to all involved in the development, we have formulated a complete product design specification in the early stage of development, thereby reducing the probability of errors during development and completing the development work on time and in the shortest time.'
    ],
    img7: require('../assets/images/article5_7.jpg'),
    desc7: [
        'Icon设计图',
        'Icon design drawing'
    ],
    img8: require('../assets/images/article5_8.jpg'),
    desc8: [
        '设计规范文件',
        'Design Specification Document'
    ],
    title4_7: [
        'B.产品规划脑图',
        'B. Product planning brain map'
    ],
    content9: [
        '作为一个专业的开发团队，Deansel在功能开发前期，也会规划出详细的产品功能细节架构图给客户确认，避免由于双方沟通误解而导致需要重新开发品产或调整产品总体架构。',
        'As a professional development team, Deansel will also plan a detailed product function detailed architecture diagram for customers to confirm in the early stage of function development, so as to avoid the need to re-develop the product or adjust the overall product architecture due to communication and misunderstanding between the two parties.'
    ],
    img9: require('../assets/images/article5_9.jpg'),
    desc9: [
        '产品功能架构',
        'Product functional architecture'
    ],
    title3_3: [
        '3.形象官网的建立',
        '3. Establishment of image official website'
    ],
    content10: [
        '为了有更多的曝光渠道，Deansel为该产品建立了形象官网，介绍产品内容。',
        'In order to have more exposure channels, Deansel established an official image website for the product to introduce the product content.'
    ],
    img10: require('../assets/images/insight_2.jpg'),
    desc10: [
        'sesame eats官网',
        'sesame eats Official website'
    ],
    title3_4: [
        '4.建立完整的可视化数据库体系',
        '4. Establish a complete visual database system'
    ],
    content11: [
        'Deansel作为一个数字驱动增长的团队，建立了可视化的数据库，让客户及团队成员可以简单轻松地通过数据分析来调整产品的方向，或是验证产品的成效。',
        'As a digital-driven growth team, Deansel has established a visual database that allows customers and team members to easily adjust the direction of the product or verify the effectiveness of the product through data analysis.'
    ],
    img11: require('../assets/images/article5_11.jpg'),
    desc11: [
        '可视化数据库',
        'Visual database'
    ],
    title3_5: [
        '5.打通线下通路',
        '5. Open up offline channels'
    ],
    content12: [
        '该项目为一个外卖业务，需要洽谈餐厅入住。为了协助W的产品能够如期上线，Deansel在其中扮演着与餐厅接洽的角色，顺利谈下10家知名餐厅加入项目的试验，并且针对餐厅做运营培训课程，确保餐厅能够在繁忙的工作中找到SOP，顺利完成工作。',
        'The project is a takeaway business and needs to negotiate the occupancy of the restaurant. In order to assist W’s products to be launched as scheduled, Deansel played a role in contacting restaurants, successfully negotiating the trial of 10 well-known restaurants to join the project, and conducting operation training courses for restaurants to ensure that restaurants can find SOPs in their busy work. , complete the work successfully.'
    ],
    title3_6: [
        '6.人潮的引流',
        '6. Divertion of crowd'
    ],
    content13: [
        '为了有效地在前期快速吸引用户，我们采取了线上整合线下的活动，串连整个产品，从线下体验-线上领取优惠卷-分享赚取积分-线下取餐，做出一个整合的营销闭环帮助产品快速地曝光及拉取新用户。',
        'In order to effectively and quickly attract users in the early stage, we have adopted online and offline activities to connect the entire product, from offline experience - online coupon collection - sharing to earn points - offline meal pickup, to make an integrated marketing closed loop helps the product to be exposed quickly and attract new users.'
    ],
    title3_7: [
        '7.内容营销-公众号的经营',
        '7. Content Marketing - Operation of Official Accounts'
    ],
    content14: [
        '在国内最基本的内容营销就是从微信公众号做起，Deansel拥有专业的公众号运营团队，每月为该产品固定撰写四篇符合市场热度及用户关注的优质文章。',
        'The most basic content marketing in China is to start from the WeChat official account. Deansel has a professional official account operation team, and writes four high-quality articles for the product every month that are in line with market popularity and user attention.'
    ],
    img12: require('../assets/images/article5_12.jpg'),
    desc12: [
        '公众号文章',
        'Official Account Articles'
    ],
    title3_8: [
        '8.创新商业模式的验证',
        '8. Validation of innovative business models'
    ],
    content15: [
        '借由两个月的产品试验，Deansel帮助W验证该创新项目是可以运行及规模化的商业模式。',
        'Through two months of product trials, Deansel helped W validate that the innovative project was a viable and scalable business model.'
    ],
}
const articleText6 = {
    title: [
        '推开转型的大门走出传统-新创商业模式',
        'Open the door of transition and stepping out of tradition - new business model'
    ],
    subtitle: [
        '副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题',
        'Subtitle'
    ],
    from_logo: '',
    from: [
        '来源：Deansel',
        'Source: Deansel'
    ],
    title2_1: [
        '外卖垃圾如何解决？',
        'How to deal with takeaway garbage?'
    ],
    content1: [
        '联合国环境署关于一次性塑料问题的研究报告显示，一次性塑料禁令或强制收费制度是全面的垃圾减量政策的先行步骤。而要实现这个问题的实质改善，还需要公众意识的提升作为助推剂。',
        'A single-use plastic ban or mandatory fee system is a first step in a comprehensive waste reduction policy, according to a UN Environment study on single-use plastics. To achieve substantial improvement in this problem, public awareness needs to be raised as a booster.'
    ],
    img1: require('../assets/images/article6_1.jpg'),
    content2: [
        '目前看来，外卖行业产生的塑料垃圾暂时还未进入政府政策视野。“外卖垃圾产生的废旧塑料其实在生活垃圾中占比还很低”，温宗国介绍，生活垃圾中的废旧塑料里仅有4%来自外卖垃圾。张淼也认为，这一现实使得政策制定者不得不将治理重点首先放在更好解决且量更大的塑料垃圾问题上，比如塑料饮料瓶和塑料袋等。针对一次性塑料袋的“限塑令”政策已执行十年。\n\n但外卖垃圾问题仅靠外卖平台也难以彻底解决。消费主义盛行之下，消费者不愿牺牲消费体验，对外卖包装要求较高，而商家为了迎合需求只能将环保因素作为次要考虑。循环经济协会副主席赵凯表示，要解决外卖垃圾问题，一方面要更加大力推广绿色消费观念，另一方面则需要加快推进新技术的发展以促进外卖行业形成循环经济的闭环。',
        'At present, it seems that the plastic waste generated by the takeaway industry has not yet entered the government’s policy vision. "Waste plastics from take-out waste actually account for a very low proportion of domestic waste," Wen Zongguo said. Only 4% of waste plastics in domestic waste come from take-out waste. Zhang Miao also believes that this reality has forced policymakers to focus on better solving and larger plastic waste problems, such as plastic beverage bottles and plastic bags. The "plastic limit order" policy for single-use plastic bags has been implemented for ten years. \n\nBut the problem of take-out garbage cannot be completely solved by the take-out platform alone. Under the prevailing consumerism, consumers are unwilling to sacrifice the consumption experience, and have higher requirements for takeaway packaging, and businesses can only take environmental protection factors as a secondary consideration in order to meet the needs. Zhao Kai, vice chairman of the Circular Economy Association, said that to solve the problem of takeaway garbage, on the one hand, it is necessary to vigorously promote the concept of green consumption, and on the other hand, it is necessary to accelerate the development of new technologies to promote the takeaway industry to form a closed loop of circular economy.'
    ],
    img2: require('../assets/images/article6_2.jpg'),
    title2_2: [
        '创新外卖产品的出现',
        'The emergence of innovative takeaway products'
    ],
    content3: [
        '近年来国内的环境保护意识越来越强，从外卖不使用一次性餐具到垃圾的分类，都是为了地球环境保护的一件美事。从外卖不使用一次性餐具的功能出现，到许多商家提高成本使用较高品质的环保餐具，可以看到大家正在为环境保护做出改变。',
        'In recent years, the awareness of environmental protection in China has become stronger and stronger. From not using disposable tableware for takeaways to sorting garbage, it is a beautiful thing for the protection of the earth. From the emergence of the function of not using disposable tableware for takeaways, to the increased cost of many businesses and the use of higher-quality environmentally friendly tableware, we can see that everyone is making changes for environmental protection.'
    ],
    img3: require('../assets/images/article6_3.jpg'),
    content4: [
        '饿了么发布的2017年中国互联网本地生活服务蓝皮书，截止至2017.12.31不使用一次性餐具的数量剧增。大家对于环境保护的意识抬头，这也是我们选择做这个实验创新产品的原因。',
        'Ele.me released the 2017 Blue Book of Internet Local Life Services in China. As of December 31, 2017, the number of not using disposable tableware has increased sharply. Everyone’s awareness of environmental protection is on the rise, which is why we chose to make this experimental and innovative product.'
    ],
    title2_3: [
        '结合用户的使用场景，不落入用户调研的误区',
        'Combined with the user’s usage scenarios, do not fall into the misunderstanding of user research'
    ],
    content5: [
        '用户调研是推荐一个产品重要的组成部分，通常会采取定量-问卷调查及定性-用户访谈，两个方式作为调研的方法。在这个项目中，前期客户已经做过一些定量及定性的调研，从这两个调研我们发现，调研的内容围绕在环保的议题上面，从这些调研的结果，可以看出用户们对于环保的意识有一个相对成熟的表现，但从这些调研结果中，找不到产品设计方向上的内容。这就导致客户在前期产品的设计上并不符合中国用户的使用习惯及需求，甚至可能导致产品在最终落地，无法有效贴近用户的行为而失败。\n\n所以我们在接到这个案子时，加入了用户场景的调研，让用户模拟他在使用场品时的环境及操作中可能会遇到的痛点，进而从这些调研中找出产品设计的方向、用户的特性及行为模式，去制作出更符合该产品的用户画像，帮助我们精准的设计产品的功能，融入环保创新的概念。用户的调研应该是一个持续性的工作，而不仅仅只是产品开发初期的工作。在案例中，前期我们的用户获取遇到一些困难，一直没有找到突破点，借由用户调研，我们才发现，原来大部分的用户根本不知道我们产品的存在。我们对用户调研的结果进行分析，重新设计了市场运营方案，成功创造出爆发性的增长。',
        'User research is an important part of recommending a product. Usually, quantitative-questionnaire surveys and qualitative-user interviews are used as research methods. In this project, the client has done some quantitative and qualitative research in the early stage. From these two surveys, we found that the content of the survey revolves around the topic of environmental protection. From the results of these surveys, we can see that users’awareness of environmental protection There is a relatively mature performance, but from these survey results, there is no content in the direction of product design. As a result, the customer’s early product design does not conform to the usage habits and needs of Chinese users, and may even lead to the failure of the product when it is finally implemented and cannot be effectively approached to the user’s behavior. \n\nSo when we received this case, we added a user scenario survey to let the user simulate the environment and pain points he may encounter when using the product, and then find out the product design from these surveys. To create a user portrait that is more in line with the product, help us accurately design the function of the product, and integrate the concept of environmental protection innovation. User research should be an ongoing work, not just a work in the early stages of product development. In the case, we encountered some difficulties in user acquisition in the early stage, and we have not found a breakthrough point. Through user research, we found that most of the users did not know the existence of our product at all. We analyzed the results of user research, redesigned the market operation plan, and successfully created explosive growth.'
    ],
    img4: require('../assets/images/article6_4.jpg'),
    content6: [
        '在这个案例中我们看到，用户的调研不能仅仅依靠定性及定量的方式，更要结合场景的融合，来帮助产品做出更符合市场及用户需求，帮助产品落地时降低进入误区的风险。用户的调研应该是一项持续进行的，而不是只有在某个时期才需要做的工作，用户调研可以帮助产品找出数据以外的事实，从而解决数据看不见的问题。',
        'In this case, we can see that user research can not only rely on qualitative and quantitative methods, but also combine the integration of scenarios to help products make products more in line with market and user needs, and help reduce the risk of entering misunderstandings when the product is launched. User research should be an ongoing work, not a job that only needs to be done in a certain period of time. User research can help products find facts beyond the data and solve the problem of invisible data.'
    ],
    title2_4: [
        '用户对于尝试创新产品愿意付出更多的成本及代价',
        'Users are willing to pay more for trying innovative products'
    ],
    content7: [
        '在前期建立用户获取模型时，考量到该创新产品的价格及操作成本较高，转化率大约会只有20％左右的人。但实际上我们达到了60%的用户获取率，这个结果出乎我们的意料。我们发现用户愿意为这样的环保创新项目付出额外的费用去尝试使用，并且愿意多花5-10分钟的时间成本用于回收餐盒。对于这样的行为，更加说明用户对于新事物的尝试保持着友善的态度，用户愿意为了环保的议题去改变自己的生活，付出更高的成本吃一顿饭。在做线下推广活动时，我们发现大约有7成的用户会主动的询问我们的项目是什么，怎么执行环保的工作等等。并且在活动的期间，即使没有利益的驱动，用户也愿意把我们的产品主动分享给他们的朋友。在高度社会化的城市中，对于环境保护及创新产品的尝试是非常有潜力的，在做产品时可以更加大胆地尝试用创新的手段去吸引用户，不需要为了获取用户而采取保守的手段，否则这样就失去了创新的意义。',
        'When establishing a user acquisition model in the early stage, considering the high price and operating cost of the innovative product, the conversion rate will only be about 20%. But we actually achieved a user acquisition rate of 60%, which was beyond our expectations. We found that users are willing to pay extra for such an environmentally friendly innovation project to try it out, and are willing to spend an extra 5-10 minutes on recycling lunch boxes. For such behavior, it shows that users maintain a friendly attitude towards trying new things, and users are willing to change their lives for environmental protection issues and pay a higher cost to eat a meal. When doing offline promotion activities, we found that about 70% of users will actively ask what our project is, how to implement environmental protection work and so on. And during the event, users are willing to share our products with their friends, even if there is no interest-driven drive. In a highly socialized city, there is great potential for attempts to protect the environment and innovative products. When making products, you can more boldly try to use innovative means to attract users, and you do not need to adopt conservative means to acquire users. Otherwise, the meaning of innovation will be lost.'
    ],
    img5: require('../assets/images/article6_5.gif'),
}
const innovationText = {
    title: [
        '整合企业资源，快速发掘和孵化新的增长模式',
        'Integrate enterprise resources to quickly discover and incubate new growth models'
    ],
    downtext: [
        '发现Deansel的能力',
        'Discover Deansel’s ability'
    ],
    subtitle: [
        '结合战略制定、社会科学、前沿科技和实事动态，用杰出的模式、产品、设计和开发能力，在企业复杂的产业链和资源结构中寻找全新的突破口，建立创新的获利模式，从而为企业的长远增长而服务。',
        'Combined with strategy formulation, social science, cutting-edge technology and practical dynamics, with outstanding models, products, design and development capabilities, we will find new breakthroughs in the complex industrial chain and resource structure of enterprises, and establish innovative profit models to serve the long-term growth of enterprises.'
    ],
    midpart1: { // 方法论1布局
        title: [
            '整合品牌的IP流量资源，打造持久的获客-运营-购买-复购循环',
            'Integrate the IP traffic resources of the brand to create a lasting customer acquisition-operation-purchase-repurchase cycle'
        ],
        content: [
            '消费品产品会积累大量的IP/流量资源，无论是线上线下还是跨界；线上IP如同线下商场内的门店一样，是持续获客的重要来源，但往往被品牌所忽视；利用企业现有资源，结合互联网的运营-转化方法论，寻找目标用户的聚集点，并打造全新的商业模式。',
            'Consumer products will accumulate a large number of IP/traffic resources, whether online or offline or cross-border; online IP, like stores in offline shopping malls, is an important source of continuous customer acquisition, but is often ignored by brands; the use of existing resources of enterprises, combined with the operation of the Internet - transformation methodology, to find the target user’s gathering point, and create a new business model.'
        ]
    },
    midpart2: { // 方法论2布局
        title: [
            '从0到1，与企业客户共同进行内部创新',
            'From 0 to 1, we work with enterprise customers on internal innovation'
        ],
        content: [
            '如何梳理用户路径寻找用户新痛点？如何持续使用MVP的思维方式建设产品实验？如何将增长黑客理论应用在企业创新中？由于理论跟实战之间存在空隙，企业一直以来都需要外部大脑带来的跨行业、跨界和跨模式的信息、解决方案和落地经验。企业内部信息和领域的专业性是确保项目落地的基石，但是其局限性也会让模式的发展受阻，盲目的跟随“新模式”很可能带来更多的困惑与不解；理解和参透企业创新增长的内在逻辑以及竞品光鲜亮丽的公关稿件背后的落地细节才是我们服务企业的要点，也是Deansel服务客户的理论支撑。\nDeansel通过结合内外大脑，市场、产品和技术精英为企业未来的增长寻求更高更强的突破。',
            'How to sort out user paths to find new user pain points? How to continuously use the MVP mindset to build product experiments? How to apply growth hacking theory to corporate innovation? Due to the gap between theory and actual combat, companies have always needed cross-industry, cross-border and cross-mode information, solutions and landing experience brought by external brains. The professionalism of the company’s internal information and field is the cornerstone to ensure the implementation of the project, but its limitations will also hinder the development of the model. Blindly following the "new model" is likely to bring more confusion and confusion; understand and penetrate the enterprise The internal logic of innovation and growth and the details behind the bright public relations manuscripts of competing products are the main points of our service enterprises and the theoretical support for Deansel to serve customers. \nDeansel seeks higher and stronger breakthroughs for the future growth of the company by combining internal and external brains, market, product and technical elites.'
        ]
    } //这里加个板式C的图片
}
const homeText = {
    top1: [
        '是否已经准备好，让你的',
        'Are you ready to let your '
    ],
    words: [
        [
            '私域流量',
            'Private traffic'
        ]
    ],
    top2: [
        '获得创新增长',
        'Gain innovation growth'
    ],
    top3: [
        '我们准备好了。',
        'Yes, we do.'
    ],
    midpart1: [
        {
            content: [
                '一场黑天鹅的疫情事件急剧加速了企业线上业务之争，如何更加精准的获得用户？如何应用精细化运营使品牌与客户建立更紧密的连接？如何在微信生态中增加新的商业化场景？',
                'A black swan epidemic has sharply accelerated the online business battle of enterprises. How to acquire users more accurately? How to apply refined operations to build a closer connection between brands and customers? How to add new commercialization scenarios to the WeChat ecosystem?'
            ]
        },
        {
            content: [
                '如何提高直播的转化率并持续带来销售额的增长？等等，成为了如今企业们聚焦的核心。产业格局的变动对各行各业战略布局产生冲击，我们专注在解读如何在新生态下获得增长与发展。',
                'How to improve the conversion rate of live broadcast and continue to bring sales growth? And so on, has become the core of today’s companies’focus. Changes in the industrial structure have an impact on the strategic layout of all walks of life. We focus on interpreting how to grow and develop in the new ecology.'
            ]
        }
    ],
    midpart2: {
        title: [
            '我们服务的项目',
            'See what we have done for some of our clients'
        ],
        cases: [
            {
                img: require('../assets/images/case_filakids.jpg'),
                title: [
                    'FILA KIDS小程序运营',
                    'FILA KIDS Mini Program operations'
                ],
                content: [
                    '为FILA KIDS提供小程序的数据、活动和日常运营服务。',
                    'Providing data, activities and daily operations of the Mini Program for FILA KIDS.'
                ]
            },
            {
                img: require('../assets/images/case_garena.jpg'),
                title: [
                    'Garena Global世界观互动',
                    'Garena Global, the interaction of World outlook'
                ],
                content: [
                    '为Garena全球提供世界观网站和网站互动服务。',
                    'Providing website service and website interactive service for Garena Global.'
                ]
            },
            {
                img: require('../assets/images/case_huazhu.jpg'),
                title: [
                    '某境外上市酒店集团',
                    'An overseas listed hotel group'
                ],
                content: [
                    '为某境外上市酒店集团提供私域建设、私域数字化落地、SCRM、CDP产品实施的DTC落地整案服务。',
                    'Provided DTC implementation services for an overseas listed hotel group, including private domain construction, private domain digitalization, SCRM, and CDP product implementation.'
                ]
            },
            {
                img: require('../assets/images/case_rog.jpg'),
                title: [
                    '国际3C巨头',
                    'International 3C giant'
                ],
                content: [
                    '为某国际3C巨头提供私域建设、私域经销商赋能、私域数字化落地的DTC落地整案服务。',
                    'Provided an international 3C giant with private domain construction, private domain dealer empowerment, and private domain digitalized DTC landing services.'
                ]
            },
            {
                img: require('../assets/images/case_runbaiyan.jpg'),
                title: [
                    '某A股上市美妆品牌',
                    'An A-share listed beauty brand'
                ],
                content: [
                    '为某A股上市美妆品牌提供私域建设、小程序开发维护、私域数字化落地的DTC落地整案服务。',
                    'Provided DTC full-case services for private domain construction, small program development and maintenance, and private domain digitalization for an A-share listed beauty brand.'
                ]
            },
            {
                img: require('../assets/images/case_sesameeats.jpg'),
                title: [
                    '新商业化场景探索',
                    'Exploration of new commercialization scenarios'
                ],
                content: [
                    '私域流量+场景营销+流量池，将增长黑客的核心方法论应用在创新增长项目中，为客户打造全新的商业化场景。',
                    'Private domain traffic + scenario marketing + traffic pool, applying the core methodology of growth hacking to innovative growth projects to create new commercial scenarios for customers.'
                ]
            }
        ]
    },
    midpart3: {
        title: [
            '我们的观点' ,
            'Our opinions'//字数可能会超过，你就直接自动隐藏就好了
        ],
        content: [
            {
                img: require('../assets/images/insight_8.jpg'),
                title: [
                    '阴云下的狂欢？疫情下跌宕起伏的线上流量战',
                    'Carnival under the dark clouds? The online traffic war with the ups and downs of the epidemic'
                ],
                content: [
                    '过去是平台的黄金时代，线上红利的存在使得能够满足C端用户需求的平台产品层出不穷，社交，电商，团购，出行，内容。平台通过聚合链接双方需求迅速聚集起大量流量，建立起了庞大的互联网帝国。',
                    'In the past, it was the golden age of platforms. The existence of online bonuses made platform products that can meet the needs of C-end users emerge in an endless stream, such as social networking, e-commerce, group buying, travel, and content. The platform quickly gathered a large amount of traffic by aggregating and linking the needs of both parties, and established a huge Internet empire.'
                ],
                url: 'https://mp.weixin.qq.com/s/w2kxG0lnt0FH9v8sGPI3SQ',
                routerUrl: ''
            },
            {
                img: require('../assets/images/tmall_1.jpg'),
                title: [
                    '天猫国际未来防晒指南：疫情下的增长新场景',
                    'Tmall Global’s Guide to Sun Protection in the Future: New Scenarios for Growth under the Epidemic'
                ],
                content: [
                    '今年是艰难的一年，新冠疫情的阴影尚笼罩在全体国民头顶，经济下行的惶恐又悄然而至。面对疫情和消费收紧带来的双重考验，线上消费更加成为企业之间争抢的必要渠道。',
                    'This year is a difficult year. The shadow of the new crown epidemic is still hanging over the heads of all the people, and the fear of economic downturn is coming quietly. In the face of the dual tests brought about by the epidemic and the tightening of consumption, online consumption has become an even more necessary channel for enterprises to compete.'
                ],
                url: '',
                routerUrl: '/article1'
            },
            {
                img: require('../assets/images/insight_2.jpg'),
                title: [
                    '创新产品：快速试错，加速成功-如何利用持续创新打造成功的商业模式',
                    'Innovative Products: Fast Trial-and-Error, Accelerated Success - How to Leverage Continuous Innovation to Create Successful Business Models'
                ],
                content: [
                    '全世界露天倾倒的塑胶垃圾有1/4在中国，一年两百万吨的外卖塑料垃圾，已经造成中国生态环境的大灾难。平均每天有2.56亿份外卖被送往用户手中，其中至少分别产生2.56亿个餐盒和塑料袋。',
                    '1/4 of the plastic waste dumped in the open air in the world is in China, and 2 million tons of take-out plastic waste a year has caused a catastrophe to China’s ecological environment. On average, 256 million takeaways are delivered to users every day, of which at least 256 million lunch boxes and plastic bags are generated.'
                ],
                url: '',
                routerUrl: '/article5'
            }
        ]
    },
    midpart4: {
        title: [
            '在帮助客户实现创新增长的同时，我们不断地收到来自客户的肯定',
            'While helping customers achieve innovative growth, we continue to receive affirmation from customers'
        ],
        content: [
            'Deansel致力于为客户提供最前沿的创新增长方案，为每一位客户提供量身定制的解决方案，在其发展的各个阶段获得变革、创新和业绩增长。',
            'Deansel is committed to providing customers with cutting-edge innovative growth solutions, providing each customer with tailor-made solutions to achieve change, innovation and performance growth at all stages of their development.'
        ],
        reviews: [
            {
                name: [
                    'Willa Zhang',
                    'Willa Zhang'
                ],
                pos: [
                    'Consulting Manager of Doblin',
                    'Consulting Manager of Doblin'
                ],
                content: [
                    'Thank you all for your hard work! And big shout out to Deansel, with their patience bringing us along the development process and their diligence in working through all the complexities.',
                    'Thank you all for your hard work! And big shout out to Deansel, with their patience bringing us along the development process and their diligence in working through all the complexities.'
                ],
                logo: require('../assets/images/willa.jpg')
            },
            {
                name: [
                    '范耀威',
                    'Adam Fan'
                ],
                pos: [
                    'CEO F5',
                    'CEO F5'
                ],
                content: [
                    'F5作为国内领先的创意机构与Deansel合作多年，Deansel拥有强大的技术团队，在技术实现上给予了我们非常大的帮助。',
                    'As a leading creative agency in China, F5 has cooperated with Deansel for many years. Deansel has a strong technical team, which has given us great help in technical realization.'
                ],
                logo: require('../assets/images/adams.jpg')
            },
            {
                name: [
                    'Grace Xu Lin',
                    'Grace Xu Lin'
                ],
                pos: [
                    'CEO VIVA',
                    'CEO VIVA'
                ],
                content: [
                    'Viva营养成立多年，成功开拓中国益生菌市场。但是，互联网时代的快速迭代让传统的益生菌公司倍感焦虑与疲惫。 在Deansel的帮助下，通过使用多种增长方法，在短短几个月时间内实现了产品GMV的跨越式增长！',
                    'Viva Nutrition has been established for many years and has successfully developed the Chinese probiotics market. However, the rapid iteration of the Internet era has made traditional probiotic companies feel anxious and exhausted. With the help of Deansel, the product GMV has grown by leaps and bounds in just a few months by using multiple growth methods!'
                ],
                logo: require('../assets/images/grace.jpg')
            },
            {
                name: [
                    'Jim Huang Jungan',
                    'Jim Huang Jungan'
                ],
                pos: [
                    'Marketing Director of ExxonMobil',
                    'Marketing Director of ExxonMobil'
                ],
                content: [
                    '埃克森美孚化工在化工领域耕耘多年，为了在中国寻求新的机会而进入塑料回收领域。在Deansel的协助下，搭建sesame eats平台，采取多样的获客策略，短短几个月内成功吸引写字楼客户，测试了新的塑料回收商业模式。',
                    'ExxonMobil Chemical, which has been working in the chemical industry for many years, entered the field of plastic recycling in order to seek new opportunities in China. With the assistance of Deansel, we built the sesame eats platform, adopted various customer acquisition strategies, successfully attracted office customers in just a few months, and tested the new plastic recycling business model.'
                ],
                logo: require('../assets/images/jim.jpg')
            },
            {
                name: [
                    'Andy West',
                    'Andy West'
                ],
                pos: [
                    'ExxonMobil Chemical, Global Polypropylene Marketing Manager',
                    'ExxonMobil Chemical, Global Polypropylene Marketing Manager'
                ],
                content: [
                    'The Deansel team were critical collaborators in our project - their speed, ingenuity and specific support in connecting with local value chains were invaluable. In general, the offering from Edward and his team is significantly fresher and more dynamic than many in this space.',
                    'The Deansel team were critical collaborators in our project - their speed, ingenuity and specific support in connecting with local value chains were invaluable. In general, the offering from Edward and his team is significantly fresher and more dynamic than many in this space.'
                ],
                logo: require('../assets/images/andy_west.jpg')
            }
        ]
    }
}
const productText = {
    title: [
        '建立\n以用户为中心的\n私域体系',
        'Establish\nuser-centric\nprivate domain system'
    ],
    subtitle: [
        '我们能够帮助您的品牌实现高效的增粉及获客，追踪并记录用户行为，建立360度的全方面用户画像，并且能够将品牌的社交数据与其他平台的数据联通，帮助您的品牌在企业微信上实现增强互动的自动化营销，增强品牌与用户的互动性，提升品牌的营销效率，建设品牌私域流量，达到品效合一并实现爆炸性的社交增长。',
        'We can help your brand achieve efficient fan growth and customer acquisition, track and record user behavior, build a 360-degree all-round user portrait, and connect your brand’s social data with data from other platforms to help your brand in the enterprise Wechat realizes automated marketing that enhances interaction, enhances the interaction between brands and users, improves brand marketing efficiency, builds brand private domain traffic, achieves the integration of product and effect, and achieves explosive social growth.'
    ],
    bannerTitle: [
        '我们的合作伙伴',
        'Our business partner'
    ],
    bannerImgs: [
        require('../assets/images/logo_xyx.jpg'),
        require('../assets/images/logo_exxon.jpg'),
        require('../assets/images/logo_hjt.jpg'),
        require('../assets/images/logo_hxsw.jpg'),
        require('../assets/images/logo_hs.jpg'),
        require('../assets/images/logo_hzh.jpg')
    ],
    coreTitle: [
        '鼎栈私域产品的六大核心',
        'Six cores of Deansel private domain products'
    ],
    coreContent: [
        {
            title: [
                '用户调研系统',
                'user research system'
            ],
            content: [
                '产出专业有效的用户调研问卷，生成专业的用户调研报告，提供运营策略的制定。',
                'Produce professional and effective user survey questionnaires, generate professional user survey reports, and provide operational strategy formulation.'
            ]
        },
        {
            title: [
                '用户生命周期跟进',
                'User lifecycle follow-up'
            ],
            content: [
                '全生命周期跟进，从用户了解品牌到预订前-预订-入住-离店-再次入住，全生命周期完整记录，自动分层用户周期，针对不同周期用户给出不同运营内容，精准触达不同生命周期的用户。',
                'Follow-up in the whole life cycle, from the user knowing the brand to pre-booking--check-in--check-out--check-in again, complete recording of the whole life cycle, automatic layering of user cycles, giving different operation contents for users in different cycles, and accurately reaching different Lifecycle of users.'
            ]
        },
        {
            title: [
                '自动化运营SOP',
                'Automated Operation SOP'
            ],
            content: [
                '自动化SOP运营是一个帮助品牌实现实时触达客户的能力，利用不同脚本设置不同的用户场景，针对用户行为触发对应的SOP，当用户触发特定SOP时自动推送消息给客户，实现实时互动、精准营销。',
                'Automated SOP operation is an ability to help brands reach customers in real time. Different scripts are used to set different user scenarios, and corresponding SOPs are triggered according to user behaviors. When users trigger specific SOPs, messages are automatically pushed to customers to achieve real-time interaction and precise marketing.'
            ]
        },
        {
            title: [
                '自动化标签系统',
                'Automated Labeling System'
            ],
            content: [
                '自动为客户打上对应标签，协助品牌有效建立完整的用户标签体系，实现用户分层管理，达到千人千面的精准营销。',
                'Automatically label customers with corresponding labels, assist brands to effectively establish a complete user label system, realize user hierarchical management, and achieve thousand-people-with-thousand-faces and precise marketing.'
            ]
        },
        {
            title: [
                '社群活跃监控',
                'Community activity monitoring'
            ],
            content: [
                '监控群内用户行为，分析用户活跃度、沉默度，找出社群活跃时间，帮助品牌有效运营社群。找到沉默用户，针对沉默用户进行唤醒工作，分析群内内容。',
                'Monitor user behavior in the group, analyze user activity and silence, find out when the community is active, and help brands effectively operate the community. Find silent users, wake up the silent users, and analyze the content in the group.'
            ]
        },
        {
            title: [
                '数据中台',
                'Data Middle Platform'
            ],
            content: [
                '我们的强大接口能力，帮助品牌将crm、App、小程序、官网、第三方微信商城、淘宝、Pos系统等平台的数据导入，完美匹配用户，协助建立完整用户画画像及用户行为监控。',
                'Our powerful interface capabilities help brands import data from platforms such as crm, App, applet, official website, third-party WeChat mall, Taobao, Pos system, etc., to perfectly match users, and assist in the establishment of complete user portraits and user behavior monitoring.'
            ]
        }
    ],
    funcTitle: [
        '核心功能介绍',
        'Introduction to core functions'
    ],
    funcContent: [
        {
            title: [
                '全数据打通',
                'All data access'
            ],
            content: [
                '我们强大的接口能力，帮助品牌将crm、App、小程序、官网、第三方微信商城、淘宝、Pos系统等平台的数据导入，完美打通所有平台，协助品牌建立完整用户画像并进行用户行为监控，实现大数据的分析能力，统一管理及运营客户。',
                'Our powerful interface capabilities help brands import data from platforms such as crm, App, applet, official website, third-party WeChat mall, Taobao, Pos system, etc., perfectly connect all platforms, assist brands to build a complete user portrait and monitor user behavior, Realize the ability to analyze big data, manage and operate customers in a unified way.'
            ],
            img: require('../assets/images/scrm_ui_1.png')
        },
        {
            title: [
                '自动化运营SOP',
                'Automated  Operation SOP'
            ],
            content: [
                '自动化运营SOP帮助品牌建立个性化内容，不仅体现在针对不同的群组进行定制化图文精准推送，还体现在：聊天对话、用户旅程设计。例如：针对会员与非会员、活跃粉丝与非活跃粉、处在不同地理位置的粉丝、不同关注来源的粉丝等，都可对其进行定制化的互动内容推送。',
                'The automated operation SOP helps brands create personalized content, not only in the precise push of customized graphics and text for different groups, but also in: chat dialogue, user journey design. For example, for members and non-members, active fans and inactive fans, fans in different geographical locations, fans with different sources of attention, etc., customized interactive content can be pushed.'
            ],
            img: require('../assets/images/scrm_ui_2.png')
        },
        {
            title: [
                '用户数据分析',
                'User data analysis'
            ],
            content: [
                '全链路的分析及报表体系能够为您提供全面的数据支持：\n- 用户分析：行为分析、标签分析、互动记录等；\n- 渠道分析：用户来源分析、活动效果分析等。',
                'The full-link analysis and reporting system can provide you with comprehensive data support:\n- User analysis: behavior analysis, tag analysis, interaction records, etc.;\n- Channel analysis: user source analysis, activity effect analysis, etc.'
            ],
            img: require('../assets/images/scrm_ui_3.png')
        },
        {
            title: [
                '用户生命周期跟进',
                'User lifecycle follow-up'
            ],
            content: [
                '全生命周期跟进，从用户了解品牌到预定前-预订-入住-离店-再次入住，全生命周期完整记录，自动分层用户周期，帮助品牌有效管理用户，针对不同生命周期的用户结合自动化运营SOP达到个性化推荐的目的。',
                'Follow-up in the whole life cycle, from users knowing the brand to pre-booking--check-in--check-out--check-in again, complete records of the whole life cycle, automatic layering of user cycles, helping brands effectively manage users, and combining automation for users with different life cycles Operation SOP achieves the purpose of personalized recommendation.'
            ],
            img: require('../assets/images/scrm_ui_4.png')
        }
    ]
}
export {
    homeText,
    overviewText,
    insightText,
    wechatText,
    ptrafficText,
    sesameeatsText,
    wildlifeText,
    huazhuText,
    consumerText,
    sportsText,
    retailText,
    tmallText,
    peopleText,
    socialText,
    marketingText,
    itddText,
    innovationText,
    productText,
    articleText1,
    articleText2,
    articleText3,
    articleText4,
    articleText5,
    articleText6,
    navText
}
